export const Distritos = [
    {
        "id": 1836,
        "codigoPais": "PER",
        "codigoDepartamento": "00",
        "codigoProvincia": "00",
        "codigoDistrito": "00",
        "nombre": "SIN RESPUESTA"
    },
    {
        "id": 1,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "A PARDO LEZAMETA"
    },
    {
        "id": 2,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "ABANCAY"
    },
    {
        "id": 3,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ACARI"
    },
    {
        "id": 4,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "01",
        "nombre": "ACAS"
    },
    {
        "id": 5,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "ACCOMARCA"
    },
    {
        "id": 6,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ACHAYA"
    },
    {
        "id": 7,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ACHOMA"
    },
    {
        "id": 8,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "ACOBAMBA"
    },
    {
        "id": 9,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ACOBAMBILLA"
    },
    {
        "id": 10,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "ACOCRO"
    },
    {
        "id": 11,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "ACOMAYO"
    },
    {
        "id": 12,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ACOPIA"
    },
    {
        "id": 13,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "ACORIA"
    },
    {
        "id": 14,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "ACOSTAMBO"
    },
    {
        "id": 15,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "AHUAC"
    },
    {
        "id": 16,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "AIJA"
    },
    {
        "id": 17,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "ALBERTO LEVEAU"
    },
    {
        "id": 18,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "15",
        "nombre": "ALONSO DE ALVARADO"
    },
    {
        "id": 19,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "ALTO BIAVO"
    },
    {
        "id": 20,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "11",
        "nombre": "ALTO INAMBARI"
    },
    {
        "id": 21,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "ALTO LARAN"
    },
    {
        "id": 22,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "ALTO SAPOSOA"
    },
    {
        "id": 23,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "28",
        "nombre": "ALTO SELVA ALEGRE"
    },
    {
        "id": 24,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "AMBAR"
    },
    {
        "id": 25,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "AMBO"
    },
    {
        "id": 26,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ANCO"
    },
    {
        "id": 27,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "ANCO HUALLO"
    },
    {
        "id": 28,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ANCON"
    },
    {
        "id": 29,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "10",
        "nombre": "ANDABAMBA"
    },
    {
        "id": 30,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "ANDAHUAYLAS"
    },
    {
        "id": 31,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "ANDAJES"
    },
    {
        "id": 32,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "ANDAMARCA"
    },
    {
        "id": 33,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "ANDARAPA"
    },
    {
        "id": 34,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "ANDARAY"
    },
    {
        "id": 35,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "ANGASMARCA"
    },
    {
        "id": 36,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "16",
        "nombre": "ANRA"
    },
    {
        "id": 37,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "ANTA"
    },
    {
        "id": 38,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "ANTABAMBA"
    },
    {
        "id": 39,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "ANTIOQUIA"
    },
    {
        "id": 40,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "APARICIO POMARES (CHUPAN)"
    },
    {
        "id": 41,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "APLAO"
    },
    {
        "id": 42,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "AQUIA"
    },
    {
        "id": 43,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "ARAHUAY"
    },
    {
        "id": 44,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "ARAPA"
    },
    {
        "id": 45,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "ARENAL"
    },
    {
        "id": 46,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "AREQUIPA"
    },
    {
        "id": 47,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "ASCENCION"
    },
    {
        "id": 48,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "16",
        "nombre": "ASIA"
    },
    {
        "id": 49,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "ASILLO"
    },
    {
        "id": 50,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "15",
        "nombre": "ASQUIPATA"
    },
    {
        "id": 51,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ASUNCION"
    },
    {
        "id": 52,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "ATAQUERO"
    },
    {
        "id": 53,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "ATAVILLOS ALTO"
    },
    {
        "id": 54,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "ATICO"
    },
    {
        "id": 55,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "ATUNCOLLA"
    },
    {
        "id": 56,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "AURAHUA"
    },
    {
        "id": 57,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "AYABACA"
    },
    {
        "id": 58,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "AYAPATA"
    },
    {
        "id": 59,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "AYAUCA"
    },
    {
        "id": 60,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "AYAVI"
    },
    {
        "id": 61,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "AYAVIRI"
    },
    {
        "id": 62,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "AYNA"
    },
    {
        "id": 63,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "AYO"
    },
    {
        "id": 64,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "AZANGARO"
    },
    {
        "id": 65,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "BAGUA GRANDE"
    },
    {
        "id": 66,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "BAJO BIAVO"
    },
    {
        "id": 67,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "BAMBAMARCA"
    },
    {
        "id": 68,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "BAMBAMARCA"
    },
    {
        "id": 69,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "BAMBAS"
    },
    {
        "id": 70,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "BARRANCA"
    },
    {
        "id": 71,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "25",
        "nombre": "BARRANCO"
    },
    {
        "id": 72,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "BARRANQUITA"
    },
    {
        "id": 73,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "BELEN"
    },
    {
        "id": 74,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "BELLA UNION"
    },
    {
        "id": 75,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "BELLAVISTA"
    },
    {
        "id": 76,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "BELLAVISTA"
    },
    {
        "id": 77,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "BELLAVISTA"
    },
    {
        "id": 78,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "BELLAVISTA DE LA UNION"
    },
    {
        "id": 79,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "BERNAL"
    },
    {
        "id": 80,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "BOLIVAR"
    },
    {
        "id": 81,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "BRENA"
    },
    {
        "id": 82,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "BUENA VISTA ALTA"
    },
    {
        "id": 83,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "BULDIBUYO"
    },
    {
        "id": 84,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "CABANILLAS"
    },
    {
        "id": 85,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CACATACHI"
    },
    {
        "id": 86,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "02",
        "nombre": "CACERES DEL PERU"
    },
    {
        "id": 87,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CACHACHI"
    },
    {
        "id": 88,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "CACHICADAN"
    },
    {
        "id": 89,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "CACRA"
    },
    {
        "id": 90,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "CAIRANI"
    },
    {
        "id": 91,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CAJABAMBA"
    },
    {
        "id": 92,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CAJAMARCA"
    },
    {
        "id": 93,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "02",
        "nombre": "CAJAMARQUILLA"
    },
    {
        "id": 94,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "CAJARURO"
    },
    {
        "id": 95,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CAJATAMBO"
    },
    {
        "id": 96,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CALANA"
    },
    {
        "id": 97,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "CALANGO"
    },
    {
        "id": 98,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CALCA"
    },
    {
        "id": 99,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "CALETA DE CARQUIN"
    },
    {
        "id": 100,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "CALLAHUANCA"
    },
    {
        "id": 101,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "CALLALLI"
    },
    {
        "id": 102,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CALLAO"
    },
    {
        "id": 103,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "CALLAYUC"
    },
    {
        "id": 104,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "CALQUIS"
    },
    {
        "id": 105,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CALZADA"
    },
    {
        "id": 106,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "CAMANA"
    },
    {
        "id": 107,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "03",
        "nombre": "CAMANTI"
    },
    {
        "id": 108,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "CANARIA"
    },
    {
        "id": 109,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "CANCHABAMBA"
    },
    {
        "id": 110,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CANCHAILLO"
    },
    {
        "id": 111,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CANGALLO"
    },
    {
        "id": 112,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "22",
        "nombre": "CANIS"
    },
    {
        "id": 113,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "CANTA"
    },
    {
        "id": 114,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CAPACHICA"
    },
    {
        "id": 115,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "codigoDistrito": "04",
        "nombre": "CAPASO"
    },
    {
        "id": 116,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CAPELO"
    },
    {
        "id": 117,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "CARABAMBA"
    },
    {
        "id": 118,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "CARACOTO"
    },
    {
        "id": 119,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CARAMPOMA"
    },
    {
        "id": 120,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "CARAPO"
    },
    {
        "id": 121,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CARHUACALLANGA"
    },
    {
        "id": 122,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "CARHUAMAYO"
    },
    {
        "id": 123,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "03",
        "nombre": "CARHUAPAMPA"
    },
    {
        "id": 124,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "CARMEN SALCEDO"
    },
    {
        "id": 125,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CARUMAS"
    },
    {
        "id": 126,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "CASA GRANDE"
    },
    {
        "id": 127,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "CASCA"
    },
    {
        "id": 128,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "CASPIZAPA"
    },
    {
        "id": 129,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CASTILLA"
    },
    {
        "id": 130,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CASTROVIRREYNA"
    },
    {
        "id": 131,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "CATACHE"
    },
    {
        "id": 132,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "33",
        "nombre": "CATAHUASI"
    },
    {
        "id": 133,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "12",
        "nombre": "CATILLUC"
    },
    {
        "id": 134,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CAYMA"
    },
    {
        "id": 135,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "CAYNARACHI"
    },
    {
        "id": 136,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "05",
        "nombre": "CCATCA"
    },
    {
        "id": 137,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CERRO COLORADO"
    },
    {
        "id": 138,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "CHACABAMBA"
    },
    {
        "id": 139,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "CHACAPAMPA"
    },
    {
        "id": 140,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CHACAYAN"
    },
    {
        "id": 141,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "CHACHAS"
    },
    {
        "id": 142,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CHACOCHE"
    },
    {
        "id": 143,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "CHAGLLA"
    },
    {
        "id": 144,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "CHALA"
    },
    {
        "id": 145,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "CHALLABAMBA"
    },
    {
        "id": 146,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "CHALLHUAHUACHO"
    },
    {
        "id": 147,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "CHAMBARA"
    },
    {
        "id": 148,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "CHANCAIBANOS"
    },
    {
        "id": 149,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "12",
        "codigoDistrito": "02",
        "nombre": "CHAO"
    },
    {
        "id": 150,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "CHAPARRA"
    },
    {
        "id": 151,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CHARAT"
    },
    {
        "id": 152,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "CHARCANA"
    },
    {
        "id": 153,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "CHAVIN DE HUANTAR"
    },
    {
        "id": 154,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CHAVIN DE PARIARCA"
    },
    {
        "id": 155,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "CHECACUPE"
    },
    {
        "id": 156,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "CHEPEN"
    },
    {
        "id": 157,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CHETILLA"
    },
    {
        "id": 158,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CHETO"
    },
    {
        "id": 159,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CHIARA"
    },
    {
        "id": 160,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "CHICAMA"
    },
    {
        "id": 161,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CHICHAS"
    },
    {
        "id": 162,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "CHIGUIRIP"
    },
    {
        "id": 163,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "CHILCAYMARCA"
    },
    {
        "id": 164,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "CHILIQUIN"
    },
    {
        "id": 165,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "CHIMBAN"
    },
    {
        "id": 166,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "01",
        "nombre": "CHIMBOTE"
    },
    {
        "id": 167,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CHINCHA ALTA"
    },
    {
        "id": 168,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CHINCHA BAJA"
    },
    {
        "id": 169,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CHINCHAYPUJIO"
    },
    {
        "id": 170,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "02",
        "nombre": "CHINCHERO"
    },
    {
        "id": 171,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CHINCHO"
    },
    {
        "id": 172,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "04",
        "nombre": "CHINGAS"
    },
    {
        "id": 173,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "CHIPAO"
    },
    {
        "id": 174,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "CHIQUIAN"
    },
    {
        "id": 175,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "CHIRINOS"
    },
    {
        "id": 176,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "CHISQUILLA"
    },
    {
        "id": 177,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CHOCHOPE"
    },
    {
        "id": 178,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "10",
        "nombre": "CHOCOS"
    },
    {
        "id": 179,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "CHOLON"
    },
    {
        "id": 180,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "CHONGOS ALTO"
    },
    {
        "id": 181,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "CHONGOS BAJO"
    },
    {
        "id": 182,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "CHONTALI"
    },
    {
        "id": 183,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "CHOROS"
    },
    {
        "id": 184,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "CHORRILLOS"
    },
    {
        "id": 185,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "CHOTA"
    },
    {
        "id": 186,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "CHUCATAMANI"
    },
    {
        "id": 187,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "CHUCUITO"
    },
    {
        "id": 188,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CHULUCANAS"
    },
    {
        "id": 189,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "CHUMUCH"
    },
    {
        "id": 190,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "CHUNGUI"
    },
    {
        "id": 191,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "CHUPA"
    },
    {
        "id": 192,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "CHUQUIBAMBA"
    },
    {
        "id": 193,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CHURUBAMBA"
    },
    {
        "id": 194,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "CHUSCHI"
    },
    {
        "id": 195,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "39",
        "nombre": "CIENEGUILLA"
    },
    {
        "id": 196,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "COASA"
    },
    {
        "id": 197,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "COCACHACRA"
    },
    {
        "id": 198,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "COCHAMARCA"
    },
    {
        "id": 199,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "04",
        "nombre": "COCHAS"
    },
    {
        "id": 200,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "COCHAS"
    },
    {
        "id": 201,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "COCHAS"
    },
    {
        "id": 202,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "COCHORCO"
    },
    {
        "id": 203,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "CODO DEL POZUZO"
    },
    {
        "id": 204,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "COJATA"
    },
    {
        "id": 205,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "COLASAY"
    },
    {
        "id": 206,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "COLCA"
    },
    {
        "id": 207,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "COLCABAMBA"
    },
    {
        "id": 208,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "COLCAMAR"
    },
    {
        "id": 209,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "COLCHA"
    },
    {
        "id": 210,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "COLQUEMARCA"
    },
    {
        "id": 211,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "COLQUEPATA"
    },
    {
        "id": 212,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "23",
        "nombre": "COLQUIOC"
    },
    {
        "id": 213,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "COLTA"
    },
    {
        "id": 214,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "COMAS"
    },
    {
        "id": 215,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "CONCEPCION"
    },
    {
        "id": 216,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CONCHAN"
    },
    {
        "id": 217,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CONDEBAMBA"
    },
    {
        "id": 218,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "CONDOROMA"
    },
    {
        "id": 219,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "CONGALLA"
    },
    {
        "id": 220,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "CONILA"
    },
    {
        "id": 221,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "13",
        "codigoDistrito": "02",
        "nombre": "CONIMA"
    },
    {
        "id": 222,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "CONTAMANA"
    },
    {
        "id": 223,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CONTUMAZA"
    },
    {
        "id": 224,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "CORACORA"
    },
    {
        "id": 225,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "CORCULLA"
    },
    {
        "id": 226,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "CORDOVA"
    },
    {
        "id": 227,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CORIS"
    },
    {
        "id": 228,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "05",
        "nombre": "COSNIPATA"
    },
    {
        "id": 229,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "COSPAN"
    },
    {
        "id": 230,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "COTABAMBAS"
    },
    {
        "id": 231,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "COTAHUASI"
    },
    {
        "id": 232,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "02",
        "nombre": "COTAPARACO"
    },
    {
        "id": 233,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "COVIRIALI"
    },
    {
        "id": 234,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "COYLLURQUI"
    },
    {
        "id": 235,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "CRISTO NOS VALGA"
    },
    {
        "id": 236,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CUCHUMBAYA"
    },
    {
        "id": 237,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "CUENCA"
    },
    {
        "id": 238,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "CUENCA"
    },
    {
        "id": 239,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "CUMBA"
    },
    {
        "id": 240,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "CURA MORI"
    },
    {
        "id": 241,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CURAHUASI"
    },
    {
        "id": 242,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "14",
        "nombre": "CURASCO"
    },
    {
        "id": 243,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "CURGOS"
    },
    {
        "id": 244,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CURIBAYA"
    },
    {
        "id": 245,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "06",
        "nombre": "CUSIPATA"
    },
    {
        "id": 246,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "CUTURAPI"
    },
    {
        "id": 247,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "CUYOCUYO"
    },
    {
        "id": 248,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "DANIEL ALOMIA ROBLES"
    },
    {
        "id": 249,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "ECHARATE"
    },
    {
        "id": 250,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "05",
        "nombre": "EDUARDO VILLANUEVA"
    },
    {
        "id": 251,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "EL ALGARROBAL"
    },
    {
        "id": 252,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "EL CARMEN"
    },
    {
        "id": 253,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "EL CARMEN"
    },
    {
        "id": 254,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "EL CARMEN DE LA FRONTERA"
    },
    {
        "id": 255,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "EL INGENIO"
    },
    {
        "id": 256,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "EL MILAGRO"
    },
    {
        "id": 257,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "EL PARCO"
    },
    {
        "id": 258,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "EL PORVENIR"
    },
    {
        "id": 259,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "EL PORVENIR"
    },
    {
        "id": 260,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "09",
        "nombre": "EL PRADO"
    },
    {
        "id": 261,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "EL TALLAN"
    },
    {
        "id": 262,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "EL TAMBO"
    },
    {
        "id": 263,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "ELEAZAR GUZMAN BARRON"
    },
    {
        "id": 264,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "ESPINAR"
    },
    {
        "id": 265,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "ESTIQUE PAMPA"
    },
    {
        "id": 266,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "ETEN PUERTO"
    },
    {
        "id": 267,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "FERNANDO LORES"
    },
    {
        "id": 268,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "FIDEL OLIVAS ESCUDERO"
    },
    {
        "id": 269,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "FITZCARRALD"
    },
    {
        "id": 270,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "FLORIDA"
    },
    {
        "id": 271,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "FRIAS"
    },
    {
        "id": 272,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "GRANADA"
    },
    {
        "id": 273,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "03",
        "nombre": "GREGORIO PITA"
    },
    {
        "id": 274,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "12",
        "codigoDistrito": "03",
        "nombre": "GUADALUPITO"
    },
    {
        "id": 275,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "GUZMANGO"
    },
    {
        "id": 276,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "10",
        "nombre": "HUAC-HUAS"
    },
    {
        "id": 277,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "HUACACHI"
    },
    {
        "id": 278,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "HUACAR"
    },
    {
        "id": 279,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "HUACCHIS"
    },
    {
        "id": 280,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "HUACHIS"
    },
    {
        "id": 281,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "HUACHOCOLPA"
    },
    {
        "id": 282,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "HUACHOCOLPA"
    },
    {
        "id": 283,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "HUACHON"
    },
    {
        "id": 284,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "HUACLLAN"
    },
    {
        "id": 285,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "HUACRACHUCO"
    },
    {
        "id": 286,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "HUAILLATI"
    },
    {
        "id": 287,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "HUALGAYOC"
    },
    {
        "id": 288,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "HUALHUAS"
    },
    {
        "id": 289,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "HUALLAGA"
    },
    {
        "id": 290,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "HUALLANCA"
    },
    {
        "id": 291,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "HUALMAY"
    },
    {
        "id": 292,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "HUAMACHUCO"
    },
    {
        "id": 293,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "HUAMALI"
    },
    {
        "id": 294,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "HUAMANCACA CHICO"
    },
    {
        "id": 295,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "HUAMANGUILLA"
    },
    {
        "id": 296,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "09",
        "nombre": "HUAMANQUIQUIA"
    },
    {
        "id": 297,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "HUAMANTANGA"
    },
    {
        "id": 298,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "HUAMBALPA"
    },
    {
        "id": 299,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "HUAMBO"
    },
    {
        "id": 300,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "HUAMBO"
    },
    {
        "id": 301,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "HUAMBOS"
    },
    {
        "id": 302,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "HUANCA"
    },
    {
        "id": 303,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "HUANCABAMBA"
    },
    {
        "id": 304,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "HUANCAN"
    },
    {
        "id": 305,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "HUANCANO"
    },
    {
        "id": 306,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "06",
        "nombre": "HUANCARANI"
    },
    {
        "id": 307,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "HUANCARAY"
    },
    {
        "id": 308,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "10",
        "nombre": "HUANCARAYLLA"
    },
    {
        "id": 309,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "HUANCARQUI"
    },
    {
        "id": 310,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "HUANCAS"
    },
    {
        "id": 311,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "HUANCAYO"
    },
    {
        "id": 312,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "HUANCHACO"
    },
    {
        "id": 313,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "HUANCHAY"
    },
    {
        "id": 314,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "HUANDO"
    },
    {
        "id": 315,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "13",
        "nombre": "HUANGASCAR"
    },
    {
        "id": 316,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "14",
        "nombre": "HUANTAN"
    },
    {
        "id": 317,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "HUANTAR"
    },
    {
        "id": 318,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "HUARAL"
    },
    {
        "id": 319,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "HUARANCHAL"
    },
    {
        "id": 320,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "HUARIACA"
    },
    {
        "id": 321,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "HUARIBAMBA"
    },
    {
        "id": 322,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "codigoDistrito": "01",
        "nombre": "HUARMEY"
    },
    {
        "id": 323,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "HUAROCHIRI"
    },
    {
        "id": 324,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "HUAROCONDO"
    },
    {
        "id": 325,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "HUASTA"
    },
    {
        "id": 326,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "HUAY HUAY"
    },
    {
        "id": 327,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "HUAYACUNDO ARMA"
    },
    {
        "id": 328,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "codigoDistrito": "03",
        "nombre": "HUAYAN"
    },
    {
        "id": 329,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "HUAYLAS"
    },
    {
        "id": 330,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "04",
        "nombre": "HUAYLLABAMBA"
    },
    {
        "id": 331,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "03",
        "nombre": "HUAYLLABAMBA"
    },
    {
        "id": 332,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "HUAYLLACAYAN"
    },
    {
        "id": 333,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "HUAYLLAN"
    },
    {
        "id": 334,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "03",
        "nombre": "HUAYLLAPAMPA"
    },
    {
        "id": 335,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "HUAYLLAY"
    },
    {
        "id": 336,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "HUAYLLAY GRANDE"
    },
    {
        "id": 337,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "HUAYNACOTAS"
    },
    {
        "id": 338,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "HUAYO"
    },
    {
        "id": 339,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "13",
        "codigoDistrito": "04",
        "nombre": "HUAYRAPATA"
    },
    {
        "id": 340,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "HUEPETUHE"
    },
    {
        "id": 341,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "HUERTAS"
    },
    {
        "id": 342,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "HUICUNGO"
    },
    {
        "id": 343,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "HUIMBAYOC"
    },
    {
        "id": 344,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "ICA"
    },
    {
        "id": 345,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "ICHUPAMPA"
    },
    {
        "id": 346,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "IGNACIO ESCUDERO"
    },
    {
        "id": 347,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "ILABAYA"
    },
    {
        "id": 348,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "codigoDistrito": "01",
        "nombre": "ILAVE"
    },
    {
        "id": 349,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "ILLIMO"
    },
    {
        "id": 350,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "INAHUAYA"
    },
    {
        "id": 351,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "INAPARI"
    },
    {
        "id": 352,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "INCAHUASI"
    },
    {
        "id": 353,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "INDEPENDENCIA"
    },
    {
        "id": 354,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "34",
        "nombre": "INDEPENDENCIA"
    },
    {
        "id": 355,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "ISLAY"
    },
    {
        "id": 356,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "ITE"
    },
    {
        "id": 357,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "IZCUCHACA"
    },
    {
        "id": 358,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "05",
        "nombre": "JACAS CHICO"
    },
    {
        "id": 359,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "JACAS GRANDE"
    },
    {
        "id": 360,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "27",
        "nombre": "JACOBO HUNTER"
    },
    {
        "id": 361,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "JANGAS"
    },
    {
        "id": 362,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "JAQUI"
    },
    {
        "id": 363,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "JAUJA"
    },
    {
        "id": 364,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "JAZAN"
    },
    {
        "id": 365,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "JEPELACIO"
    },
    {
        "id": 366,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "JESUS"
    },
    {
        "id": 367,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "33",
        "nombre": "JESUS MARIA"
    },
    {
        "id": 368,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "JESUS NAZARENO"
    },
    {
        "id": 369,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "JILILI"
    },
    {
        "id": 370,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "JIRCAN"
    },
    {
        "id": 371,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "JORGE CHAVEZ"
    },
    {
        "id": 372,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "JOSE GALVEZ"
    },
    {
        "id": 373,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "JOSE LEONARDO ORTIZ"
    },
    {
        "id": 374,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "29",
        "nombre": "JOSE LUIS BUSTAMANTE Y RIVERO"
    },
    {
        "id": 375,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "04",
        "nombre": "JOSE MANUEL QUIROZ"
    },
    {
        "id": 376,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "JOSE MARIA QUIMPER"
    },
    {
        "id": 377,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "JUAN ESPINOZA MEDRANO"
    },
    {
        "id": 378,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "JUANJUI"
    },
    {
        "id": 379,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "JULI"
    },
    {
        "id": 380,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "JULIACA"
    },
    {
        "id": 381,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "JUMBILLA"
    },
    {
        "id": 382,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "17",
        "nombre": "JUSTO APU SAHUARAURA"
    },
    {
        "id": 383,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "12",
        "nombre": "KELLUYO"
    },
    {
        "id": 384,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "09",
        "nombre": "KIMBIRI"
    },
    {
        "id": 385,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "KUNTURKANKI"
    },
    {
        "id": 386,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "LA CRUZ"
    },
    {
        "id": 387,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "LA CUESTA"
    },
    {
        "id": 388,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "LA JALCA"
    },
    {
        "id": 389,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "LA MERCED"
    },
    {
        "id": 390,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "LA MERCED"
    },
    {
        "id": 391,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "LA OROYA"
    },
    {
        "id": 392,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "LA PAMPA"
    },
    {
        "id": 393,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "LA PECA"
    },
    {
        "id": 394,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "24",
        "nombre": "LA PRIMAVERA"
    },
    {
        "id": 395,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "LAGUNAS"
    },
    {
        "id": 396,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "LAGUNAS"
    },
    {
        "id": 397,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "LAMAS"
    },
    {
        "id": 398,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "LAMBAYEQUE"
    },
    {
        "id": 399,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "LAMPA"
    },
    {
        "id": 400,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "LAMPIAN"
    },
    {
        "id": 401,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "LAMUD"
    },
    {
        "id": 402,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "LANCONES"
    },
    {
        "id": 403,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "LANGA"
    },
    {
        "id": 404,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "LANGUI"
    },
    {
        "id": 405,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "LAREDO"
    },
    {
        "id": 406,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "LAS LOMAS"
    },
    {
        "id": 407,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "11",
        "nombre": "LAS PIRIAS"
    },
    {
        "id": 408,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "LAYO"
    },
    {
        "id": 409,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "LEIMEBAMBA"
    },
    {
        "id": 410,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "LEONCIO PRADO"
    },
    {
        "id": 411,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "LEONCIO PRADO"
    },
    {
        "id": 412,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "LEONOR ORDONEZ"
    },
    {
        "id": 413,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "LEVANTO"
    },
    {
        "id": 414,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "LIMA"
    },
    {
        "id": 415,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "LIMABAMBA"
    },
    {
        "id": 416,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "LIMATAMBO"
    },
    {
        "id": 417,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "LINCE"
    },
    {
        "id": 418,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "17",
        "nombre": "LINCHA"
    },
    {
        "id": 419,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "LIRCAY"
    },
    {
        "id": 420,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "LIVITACA"
    },
    {
        "id": 421,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "LLACANORA"
    },
    {
        "id": 422,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "09",
        "nombre": "LLACLLIN"
    },
    {
        "id": 423,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "01",
        "nombre": "LLAMELLIN"
    },
    {
        "id": 424,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "LLAPA"
    },
    {
        "id": 425,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "LLATA"
    },
    {
        "id": 426,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "14",
        "nombre": "LLAUTA"
    },
    {
        "id": 427,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "LLAYLLA"
    },
    {
        "id": 428,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "LLOCHEGUA"
    },
    {
        "id": 429,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "LLUSCO"
    },
    {
        "id": 430,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "LLUTA"
    },
    {
        "id": 431,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "LOBITOS"
    },
    {
        "id": 432,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "LOCUMBA"
    },
    {
        "id": 433,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "LOMAS"
    },
    {
        "id": 434,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "LONGAR"
    },
    {
        "id": 435,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "LOS AQUIJES"
    },
    {
        "id": 436,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "42",
        "nombre": "LOS OLIVOS"
    },
    {
        "id": 437,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "LOS ORGANOS"
    },
    {
        "id": 438,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "13",
        "nombre": "LUCANAS"
    },
    {
        "id": 439,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "LUCMA"
    },
    {
        "id": 440,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "LURICOCHA"
    },
    {
        "id": 441,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "LURIN"
    },
    {
        "id": 442,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "LUYANDO"
    },
    {
        "id": 443,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "12",
        "nombre": "MACA"
    },
    {
        "id": 444,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "MACHAGUAY"
    },
    {
        "id": 445,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "04",
        "nombre": "MACHUPICCHU"
    },
    {
        "id": 446,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "31",
        "nombre": "MADEAN"
    },
    {
        "id": 447,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "MADRE DE DIOS"
    },
    {
        "id": 448,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "13",
        "nombre": "MADRIGAL"
    },
    {
        "id": 449,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "MAGDALENA"
    },
    {
        "id": 450,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "MAGDALENA"
    },
    {
        "id": 451,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "MAGDALENA DEL MAR"
    },
    {
        "id": 452,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "20",
        "nombre": "MAJES"
    },
    {
        "id": 453,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "MALA"
    },
    {
        "id": 454,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "MAMARA"
    },
    {
        "id": 455,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "MANAS"
    },
    {
        "id": 456,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "MANCORA"
    },
    {
        "id": 457,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "13",
        "nombre": "MANGAS"
    },
    {
        "id": 458,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "MANSERICHE"
    },
    {
        "id": 459,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "MANTA"
    },
    {
        "id": 460,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "MANU"
    },
    {
        "id": 461,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "MANUEL ANTONIO MESONES MURO"
    },
    {
        "id": 462,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "MAQUIA"
    },
    {
        "id": 463,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "MARANURA"
    },
    {
        "id": 464,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "MARCAPOMACOCHA"
    },
    {
        "id": 465,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "14",
        "nombre": "MARCO"
    },
    {
        "id": 466,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "MARCONA"
    },
    {
        "id": 467,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "MARIA"
    },
    {
        "id": 468,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "MARIAS"
    },
    {
        "id": 469,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "MARISCAL CACERES"
    },
    {
        "id": 470,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "MARISCAL CACERES"
    },
    {
        "id": 471,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "MARISCAL RAMON CASTILLA"
    },
    {
        "id": 472,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "MASIN"
    },
    {
        "id": 473,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "MASISEA"
    },
    {
        "id": 474,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "15",
        "nombre": "MASMA"
    },
    {
        "id": 475,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "MATAHUASI"
    },
    {
        "id": 476,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "MATARA"
    },
    {
        "id": 477,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "MCAL BENAVIDES"
    },
    {
        "id": 478,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "MEJIA"
    },
    {
        "id": 479,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "MICAELA BASTIDAS"
    },
    {
        "id": 480,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "MIGUEL IGLESIAS"
    },
    {
        "id": 481,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "MIRAFLORES"
    },
    {
        "id": 482,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "MIRAFLORES"
    },
    {
        "id": 483,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "MIRAFLORES"
    },
    {
        "id": 484,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "13",
        "codigoDistrito": "01",
        "nombre": "MOHO"
    },
    {
        "id": 485,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "MOLLEBAMBA"
    },
    {
        "id": 486,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "MOLLEBAYA"
    },
    {
        "id": 487,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "14",
        "nombre": "MOLLEPAMPA"
    },
    {
        "id": 488,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "MOLLEPATA"
    },
    {
        "id": 489,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "17",
        "nombre": "MONOBAMBA"
    },
    {
        "id": 490,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "MONTEVIDEO"
    },
    {
        "id": 491,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "MONZON"
    },
    {
        "id": 492,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "11",
        "nombre": "MORCOLLA"
    },
    {
        "id": 493,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "MORONA"
    },
    {
        "id": 494,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "MORROPE"
    },
    {
        "id": 495,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "MORROPON"
    },
    {
        "id": 496,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "MOSOC LLACTA"
    },
    {
        "id": 497,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "MOTUPE"
    },
    {
        "id": 498,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "MOYA"
    },
    {
        "id": 499,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "MOYOBAMBA"
    },
    {
        "id": 500,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "19",
        "nombre": "MUQUIYAUYO"
    },
    {
        "id": 501,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "MUSGA"
    },
    {
        "id": 502,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "NAMBALLE"
    },
    {
        "id": 503,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "NAMORA"
    },
    {
        "id": 504,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "NAUTA"
    },
    {
        "id": 505,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "NAZCA"
    },
    {
        "id": 506,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "05",
        "nombre": "NEPEÑA"
    },
    {
        "id": 507,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "NICASIO"
    },
    {
        "id": 508,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "NICOLAS DE PIEROLA"
    },
    {
        "id": 509,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "NIEVA"
    },
    {
        "id": 510,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "NINACACA"
    },
    {
        "id": 511,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "NUEVA CAJAMARCA"
    },
    {
        "id": 512,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "NUEVO OCCORO"
    },
    {
        "id": 513,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "NUEVO PROGRESO"
    },
    {
        "id": 514,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "NUNOA"
    },
    {
        "id": 515,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "12",
        "nombre": "OCALLI"
    },
    {
        "id": 516,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "OCONA"
    },
    {
        "id": 517,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "10",
        "nombre": "OCONGATE"
    },
    {
        "id": 518,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "OCOYO"
    },
    {
        "id": 519,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "OCROS"
    },
    {
        "id": 520,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "OCUCAJE"
    },
    {
        "id": 521,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "OCUVIRI"
    },
    {
        "id": 522,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "06",
        "nombre": "OLLANTAYTAMBO"
    },
    {
        "id": 523,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "OLLARAYA"
    },
    {
        "id": 524,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "OLLEROS"
    },
    {
        "id": 525,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "OLLEROS"
    },
    {
        "id": 526,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "19",
        "nombre": "OMAS"
    },
    {
        "id": 527,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ONGOY"
    },
    {
        "id": 528,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "OROPESA"
    },
    {
        "id": 529,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "OYOTUN"
    },
    {
        "id": 530,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "20",
        "nombre": "PACA"
    },
    {
        "id": 531,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "PACAPAUSA"
    },
    {
        "id": 532,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "PACARAOS"
    },
    {
        "id": 533,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "PACAYCASA"
    },
    {
        "id": 534,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "08",
        "nombre": "PACCARITAMBO"
    },
    {
        "id": 535,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "21",
        "nombre": "PACCHA"
    },
    {
        "id": 536,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "PACCHO"
    },
    {
        "id": 537,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "PACHACAMAC"
    },
    {
        "id": 538,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "14",
        "nombre": "PACHAS"
    },
    {
        "id": 539,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "PACHIA"
    },
    {
        "id": 540,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "15",
        "nombre": "PACLLON"
    },
    {
        "id": 541,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "PACOCHA"
    },
    {
        "id": 542,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "13",
        "nombre": "PACUCHA"
    },
    {
        "id": 543,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "PADRE ABAD"
    },
    {
        "id": 544,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PAIJAN"
    },
    {
        "id": 545,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "PAIMAS"
    },
    {
        "id": 546,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "PAJARILLO"
    },
    {
        "id": 547,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "PALCA"
    },
    {
        "id": 548,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "PALCA"
    },
    {
        "id": 549,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "PALCAZU"
    },
    {
        "id": 550,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "PALPA"
    },
    {
        "id": 551,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "PAMPA HERMOSA"
    },
    {
        "id": 552,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "PAMPACHIRI"
    },
    {
        "id": 553,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "10",
        "nombre": "PAMPACOLCA"
    },
    {
        "id": 554,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "PAMPAMARCA"
    },
    {
        "id": 555,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "07",
        "nombre": "PAMPAMARCA"
    },
    {
        "id": 556,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "09",
        "nombre": "PAMPAS"
    },
    {
        "id": 557,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "PAMPAS"
    },
    {
        "id": 558,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "22",
        "nombre": "PANCAN"
    },
    {
        "id": 559,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "PARAMONGA"
    },
    {
        "id": 560,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "PARANDAY"
    },
    {
        "id": 561,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "06",
        "nombre": "PARARIN"
    },
    {
        "id": 562,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "PARAS"
    },
    {
        "id": 563,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "23",
        "nombre": "PARCO"
    },
    {
        "id": 564,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "PARCOY"
    },
    {
        "id": 565,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "PARIACOTO"
    },
    {
        "id": 566,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "PARIAHUANCA"
    },
    {
        "id": 567,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "22",
        "nombre": "PARIAHUANCA"
    },
    {
        "id": 568,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "PARINARI"
    },
    {
        "id": 569,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "PARINAS"
    },
    {
        "id": 570,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "PAROBAMBA"
    },
    {
        "id": 571,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "PARURO"
    },
    {
        "id": 572,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PATAMBUCO"
    },
    {
        "id": 573,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "PATAYPAMPA"
    },
    {
        "id": 574,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "PATAZ"
    },
    {
        "id": 575,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "PAUCARPATA"
    },
    {
        "id": 576,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "PAUCARTAMBO"
    },
    {
        "id": 577,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "PAUSA"
    },
    {
        "id": 578,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "17",
        "nombre": "PAZOS"
    },
    {
        "id": 579,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "PIAS"
    },
    {
        "id": 580,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "PICHANAQUI"
    },
    {
        "id": 581,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "10",
        "nombre": "PICHARI"
    },
    {
        "id": 582,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "PICHIRHUA"
    },
    {
        "id": 583,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "PICSI"
    },
    {
        "id": 584,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "PILLCO MARCA"
    },
    {
        "id": 585,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "PILLUANA"
    },
    {
        "id": 586,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "PILPICHACA"
    },
    {
        "id": 587,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "PIMENTEL"
    },
    {
        "id": 588,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "PINRA"
    },
    {
        "id": 589,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "PIRA"
    },
    {
        "id": 590,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "PISCO"
    },
    {
        "id": 591,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "14",
        "nombre": "PISUQUIA"
    },
    {
        "id": 592,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "PITIPO"
    },
    {
        "id": 593,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "PIURA"
    },
    {
        "id": 594,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "POLVORA"
    },
    {
        "id": 595,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "24",
        "nombre": "POMACANCHA"
    },
    {
        "id": 596,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "POMALCA"
    },
    {
        "id": 597,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "POMATA"
    },
    {
        "id": 598,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "POROY"
    },
    {
        "id": 599,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "POSIC"
    },
    {
        "id": 600,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "POZUZO"
    },
    {
        "id": 601,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "PROGRESO"
    },
    {
        "id": 602,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "23",
        "nombre": "PROVIDENCIA"
    },
    {
        "id": 603,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "PUCALA"
    },
    {
        "id": 604,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PUCARA"
    },
    {
        "id": 605,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "24",
        "nombre": "PUCARA"
    },
    {
        "id": 606,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "PUCARA"
    },
    {
        "id": 607,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "PUEBLO NUEVO"
    },
    {
        "id": 608,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "PUEBLO NUEVO"
    },
    {
        "id": 609,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "PUENTE PIEDRA"
    },
    {
        "id": 610,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "PUERTO BERMUDEZ"
    },
    {
        "id": 611,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "PUINAHUA"
    },
    {
        "id": 612,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "PULAN"
    },
    {
        "id": 613,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "PULLO"
    },
    {
        "id": 614,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "PUNCHAO"
    },
    {
        "id": 615,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "PUNTA HERMOSA"
    },
    {
        "id": 616,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "PURUS"
    },
    {
        "id": 617,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "32",
        "nombre": "PUTINZA"
    },
    {
        "id": 618,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "PUTUMAYO"
    },
    {
        "id": 619,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "PUYUSCA"
    },
    {
        "id": 620,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "QUEHUE"
    },
    {
        "id": 621,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "QUEQUENA"
    },
    {
        "id": 622,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "QUERECOTILLO"
    },
    {
        "id": 623,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "QUEROBAMBA"
    },
    {
        "id": 624,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "QUIACA"
    },
    {
        "id": 625,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "12",
        "nombre": "QUICACHA"
    },
    {
        "id": 626,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "25",
        "nombre": "QUICHUAY"
    },
    {
        "id": 627,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "QUILCA PUNCU"
    },
    {
        "id": 628,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "QUILMANA"
    },
    {
        "id": 629,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "QUINISTAQUILLAS"
    },
    {
        "id": 630,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "21",
        "nombre": "QUINOCAY"
    },
    {
        "id": 631,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "QUINUA"
    },
    {
        "id": 632,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "QUIRUVILCA"
    },
    {
        "id": 633,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "18",
        "nombre": "QUISHUAR"
    },
    {
        "id": 634,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "QUISQUI"
    },
    {
        "id": 635,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "11",
        "nombre": "RAHUAPAMPA"
    },
    {
        "id": 636,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "RAIMONDI"
    },
    {
        "id": 637,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "RANRACANCHA"
    },
    {
        "id": 638,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "06",
        "nombre": "RANRAHIRCA"
    },
    {
        "id": 639,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "12",
        "nombre": "RAPAYAN"
    },
    {
        "id": 640,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "RECTA"
    },
    {
        "id": 641,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "RIO GRANDE"
    },
    {
        "id": 642,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "RIO NEGRO"
    },
    {
        "id": 643,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "RIO SANTIAGO"
    },
    {
        "id": 644,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "RIO TAMBO"
    },
    {
        "id": 645,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "17",
        "nombre": "RIPAN"
    },
    {
        "id": 646,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "ROSARIO"
    },
    {
        "id": 647,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "SACHACA"
    },
    {
        "id": 648,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "29",
        "nombre": "SAISA"
    },
    {
        "id": 649,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "SALLIQUE"
    },
    {
        "id": 650,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "SAMA"
    },
    {
        "id": 651,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "SAN ANDRES"
    },
    {
        "id": 652,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "15",
        "nombre": "SAN ANTONIO"
    },
    {
        "id": 653,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "SAN ANTONIO"
    },
    {
        "id": 654,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "14",
        "nombre": "SAN ANTONIO DE CHUCA"
    },
    {
        "id": 655,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "23",
        "nombre": "SAN BARTOLO"
    },
    {
        "id": 656,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "13",
        "codigoDistrito": "02",
        "nombre": "SAN BERNARDINO"
    },
    {
        "id": 657,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "SAN BUENAVENTURA"
    },
    {
        "id": 658,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "15",
        "nombre": "SAN CRISTOBAL"
    },
    {
        "id": 659,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "08",
        "nombre": "SAN CRISTOBAL DE RAJAN"
    },
    {
        "id": 660,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "17",
        "nombre": "SAN DAMIAN"
    },
    {
        "id": 661,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SAN FCO DE CAYRAN"
    },
    {
        "id": 662,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "15",
        "nombre": "SAN FCO DE RAVACAYCO"
    },
    {
        "id": 663,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "SAN FERNANDO"
    },
    {
        "id": 664,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "16",
        "nombre": "SAN FRANCISCO DE YESO"
    },
    {
        "id": 665,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "SAN GABAN"
    },
    {
        "id": 666,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "SAN GREGORIO"
    },
    {
        "id": 667,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "SAN HILARION"
    },
    {
        "id": 668,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "24",
        "nombre": "SAN ISIDRO"
    },
    {
        "id": 669,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "SAN JACINTO"
    },
    {
        "id": 670,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "17",
        "nombre": "SAN JERONIMO"
    },
    {
        "id": 671,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "SAN JERONIMO"
    },
    {
        "id": 672,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "SAN JERONIMO"
    },
    {
        "id": 673,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "28",
        "nombre": "SAN JERONIMO DE TUNAN"
    },
    {
        "id": 674,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "SAN JOSE"
    },
    {
        "id": 675,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "SAN JOSE"
    },
    {
        "id": 676,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "06",
        "nombre": "SAN JOSE DE LOURDES"
    },
    {
        "id": 677,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "SAN JOSE DE SISA"
    },
    {
        "id": 678,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SAN JOSE DE TICLLAS"
    },
    {
        "id": 679,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "09",
        "nombre": "SAN JOSE DE USHUA"
    },
    {
        "id": 680,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "09",
        "nombre": "SAN JOSE DEL ALTO"
    },
    {
        "id": 681,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "SAN JUAN"
    },
    {
        "id": 682,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "SAN JUAN BAUTISTA"
    },
    {
        "id": 683,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "SAN JUAN BAUTISTA"
    },
    {
        "id": 684,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "SAN JUAN DE BIGOTE"
    },
    {
        "id": 685,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "SAN JUAN DE CUTERVO"
    },
    {
        "id": 686,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "SAN JUAN DE JARPA"
    },
    {
        "id": 687,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SAN JUAN DE LA VIRGEN"
    },
    {
        "id": 688,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "17",
        "nombre": "SAN JUAN DE LICUPIS"
    },
    {
        "id": 689,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "15",
        "nombre": "SAN JUAN DE SALINAS"
    },
    {
        "id": 690,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "SAN JUAN DE SIGUAS"
    },
    {
        "id": 691,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "SAN JUAN DE TARUCANI"
    },
    {
        "id": 692,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "SAN JUAN DE YANAC"
    },
    {
        "id": 693,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "SAN JUAN DEL ORO"
    },
    {
        "id": 694,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "13",
        "codigoDistrito": "03",
        "nombre": "SAN LUIS"
    },
    {
        "id": 695,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "10",
        "nombre": "SAN LUIS DE LUCMA"
    },
    {
        "id": 696,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "20",
        "nombre": "SAN MARCOS DE ROCCHAC"
    },
    {
        "id": 697,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "SAN MARTIN"
    },
    {
        "id": 698,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "21",
        "nombre": "SAN MATEO"
    },
    {
        "id": 699,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "SAN MIGUEL"
    },
    {
        "id": 700,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "SAN MIGUEL DE ACO"
    },
    {
        "id": 701,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "09",
        "nombre": "SAN MIGUEL DE ACOS"
    },
    {
        "id": 702,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "SAN MIGUEL DE MAYOC"
    },
    {
        "id": 703,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "SAN NICOLAS"
    },
    {
        "id": 704,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "17",
        "codigoDistrito": "03",
        "nombre": "SAN NICOLAS"
    },
    {
        "id": 705,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "13",
        "codigoDistrito": "01",
        "nombre": "SAN PABLO"
    },
    {
        "id": 706,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "SAN PABLO"
    },
    {
        "id": 707,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "SAN PABLO"
    },
    {
        "id": 708,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "22",
        "nombre": "SAN PEDRO"
    },
    {
        "id": 709,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "SAN PEDRO DE CAJAS"
    },
    {
        "id": 710,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "14",
        "nombre": "SAN PEDRO DE CHANA"
    },
    {
        "id": 711,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "SAN PEDRO DE CHAULAN"
    },
    {
        "id": 712,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "SAN PEDRO DE LLOC"
    },
    {
        "id": 713,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "SAN RAMON"
    },
    {
        "id": 714,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "08",
        "nombre": "SAN SILVESTRE DE COCHAN"
    },
    {
        "id": 715,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "SANA"
    },
    {
        "id": 716,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "SANAGORAN"
    },
    {
        "id": 717,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "SANAICA"
    },
    {
        "id": 718,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "20",
        "nombre": "SANCOS"
    },
    {
        "id": 719,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "SANCOS"
    },
    {
        "id": 720,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "18",
        "nombre": "SANGALLAYA"
    },
    {
        "id": 721,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "07",
        "nombre": "SANTA"
    },
    {
        "id": 722,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "19",
        "nombre": "SANTA CATALINA"
    },
    {
        "id": 723,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 724,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 725,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "SANTA CRUZ DE CHUCA"
    },
    {
        "id": 726,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "25",
        "nombre": "SANTA EULALIA"
    },
    {
        "id": 727,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "SANTA LEONOR"
    },
    {
        "id": 728,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "SANTA LUCIA"
    },
    {
        "id": 729,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "SANTA MARIA"
    },
    {
        "id": 730,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 731,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "codigoDistrito": "03",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 732,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 733,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "SANTA ROSA DE QUIVES"
    },
    {
        "id": 734,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SANTIAGO"
    },
    {
        "id": 735,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "SANTIAGO"
    },
    {
        "id": 736,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "26",
        "nombre": "SANTIAGO DE ANCHUCAYA"
    },
    {
        "id": 737,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "SANTIAGO DE CAO"
    },
    {
        "id": 738,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "13",
        "nombre": "SANTIAGO DE CHALLAS"
    },
    {
        "id": 739,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "10",
        "nombre": "SANTIAGO DE CHILCAS"
    },
    {
        "id": 740,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "13",
        "nombre": "SANTIAGO DE CHOCORVOS"
    },
    {
        "id": 741,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "SANTIAGO DE LUCANAMARCA"
    },
    {
        "id": 742,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "06",
        "nombre": "SANTIAGO DE PAUCARAY"
    },
    {
        "id": 743,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "30",
        "nombre": "SANTIAGO DE SURCO"
    },
    {
        "id": 744,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "27",
        "nombre": "SANTIAGO DE TUNA"
    },
    {
        "id": 745,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "15",
        "nombre": "SANTO DOMINGO DE CAPILLA"
    },
    {
        "id": 746,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "SANTO TOMAS"
    },
    {
        "id": 747,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "10",
        "nombre": "SANTO TORIBIO"
    },
    {
        "id": 748,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "33",
        "nombre": "SAPALLANGA"
    },
    {
        "id": 749,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "SAPILLICA"
    },
    {
        "id": 750,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "SAPOSOA"
    },
    {
        "id": 751,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "SAQUENA"
    },
    {
        "id": 752,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "10",
        "nombre": "SARA SARA"
    },
    {
        "id": 753,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "SARTIMBAMBA"
    },
    {
        "id": 754,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "SATIPO"
    },
    {
        "id": 755,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "13",
        "nombre": "SAYAN"
    },
    {
        "id": 756,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "SAYAPULLO"
    },
    {
        "id": 757,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "SAYLA"
    },
    {
        "id": 758,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "SECCLLA"
    },
    {
        "id": 759,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "SEPAHUA"
    },
    {
        "id": 760,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "SEXI"
    },
    {
        "id": 761,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "20",
        "nombre": "SHAPAJA"
    },
    {
        "id": 762,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "SHUNTE"
    },
    {
        "id": 763,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "07",
        "nombre": "SHUPLUY"
    },
    {
        "id": 764,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "34",
        "nombre": "SICAYA"
    },
    {
        "id": 765,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "06",
        "nombre": "SICSIBAMBA"
    },
    {
        "id": 766,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "22",
        "nombre": "SILLAPATA"
    },
    {
        "id": 767,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SIMBAL"
    },
    {
        "id": 768,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "codigoDistrito": "05",
        "nombre": "SINA"
    },
    {
        "id": 769,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "SINGA"
    },
    {
        "id": 770,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "SINSICAP"
    },
    {
        "id": 771,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "SITABAMBA"
    },
    {
        "id": 772,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "SITACOCHA"
    },
    {
        "id": 773,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "SIVIA"
    },
    {
        "id": 774,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "SOCABAYA"
    },
    {
        "id": 775,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "14",
        "nombre": "SOCOTA"
    },
    {
        "id": 776,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "SOPLIN"
    },
    {
        "id": 777,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "08",
        "nombre": "SORAS"
    },
    {
        "id": 778,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "28",
        "nombre": "STA MARIA DEL MAR"
    },
    {
        "id": 779,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "STA MARIA DEL VALLE"
    },
    {
        "id": 780,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "31",
        "nombre": "STO DOMINGO DE ACOBAMBA"
    },
    {
        "id": 781,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "STO TOMAS DE PATA"
    },
    {
        "id": 782,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "SUCRE"
    },
    {
        "id": 783,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "SULLANA"
    },
    {
        "id": 784,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "SUPE"
    },
    {
        "id": 785,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "SUPE PUERTO"
    },
    {
        "id": 786,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "29",
        "nombre": "SURCO"
    },
    {
        "id": 787,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "31",
        "nombre": "SURQUILLO"
    },
    {
        "id": 788,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "13",
        "nombre": "TABALOSOS"
    },
    {
        "id": 789,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "15",
        "nombre": "TACABAMBA"
    },
    {
        "id": 790,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "TACNA"
    },
    {
        "id": 791,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "TAHUAMANU"
    },
    {
        "id": 792,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "TAMBILLO"
    },
    {
        "id": 793,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "16",
        "nombre": "TAMBO"
    },
    {
        "id": 794,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "TAMBOBAMBA"
    },
    {
        "id": 795,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "24",
        "nombre": "TANTA"
    },
    {
        "id": 796,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "TANTAMAYO"
    },
    {
        "id": 797,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "27",
        "nombre": "TANTARA"
    },
    {
        "id": 798,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "TANTARICA"
    },
    {
        "id": 799,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "07",
        "nombre": "TAPACOCHA"
    },
    {
        "id": 800,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "TAPO"
    },
    {
        "id": 801,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "TAPUC"
    },
    {
        "id": 802,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "TARACO"
    },
    {
        "id": 803,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "TARAPOTO"
    },
    {
        "id": 804,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "TARATA"
    },
    {
        "id": 805,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "TARAY"
    },
    {
        "id": 806,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "TARICA"
    },
    {
        "id": 807,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "TARMA"
    },
    {
        "id": 808,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "12",
        "nombre": "TARUCACHI"
    },
    {
        "id": 809,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "TATE"
    },
    {
        "id": 810,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "TAURIJA"
    },
    {
        "id": 811,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "TAYABAMBA"
    },
    {
        "id": 812,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "TICLACAYAN"
    },
    {
        "id": 813,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "20",
        "nombre": "TICLLOS"
    },
    {
        "id": 814,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "TINTA"
    },
    {
        "id": 815,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "TINYAHUARCO"
    },
    {
        "id": 816,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "TIQUILLACA"
    },
    {
        "id": 817,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "17",
        "nombre": "TIRAPATA"
    },
    {
        "id": 818,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "17",
        "nombre": "TISCO"
    },
    {
        "id": 819,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "TNTE CESAR LOPEZ ROJAS"
    },
    {
        "id": 820,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "TNTE MANUEL CLAVERO"
    },
    {
        "id": 821,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "TOCACHE"
    },
    {
        "id": 822,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "11",
        "nombre": "TONGOD"
    },
    {
        "id": 823,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "TORATA"
    },
    {
        "id": 824,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "TORRES CAUSANA"
    },
    {
        "id": 825,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "TROMPETEROS"
    },
    {
        "id": 826,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "TRUJILLO"
    },
    {
        "id": 827,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "TUMAN"
    },
    {
        "id": 828,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "16",
        "nombre": "TUMAY HUARACA"
    },
    {
        "id": 829,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "TUMBES"
    },
    {
        "id": 830,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "TUPAC AMARU"
    },
    {
        "id": 831,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "TUPAC AMARU INCA"
    },
    {
        "id": 832,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "26",
        "nombre": "TUPE"
    },
    {
        "id": 833,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "TURPAY"
    },
    {
        "id": 834,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "18",
        "nombre": "TUTI"
    },
    {
        "id": 835,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "UBINAS"
    },
    {
        "id": 836,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "UCUNCHA"
    },
    {
        "id": 837,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "ULCUMAYO"
    },
    {
        "id": 838,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "09",
        "nombre": "UMACHIRI"
    },
    {
        "id": 839,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "UNICACHI"
    },
    {
        "id": 840,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "13",
        "nombre": "UNON"
    },
    {
        "id": 841,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "URACA"
    },
    {
        "id": 842,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "01",
        "nombre": "URCOS"
    },
    {
        "id": 843,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "URPAY"
    },
    {
        "id": 844,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "01",
        "nombre": "URUBAMBA"
    },
    {
        "id": 845,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "USICAYOS"
    },
    {
        "id": 846,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "UTCO"
    },
    {
        "id": 847,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "VARGAS GUERRA"
    },
    {
        "id": 848,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "VEINTISEIS DE OCTUBRE"
    },
    {
        "id": 849,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "VENTANILLA"
    },
    {
        "id": 850,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "VICE"
    },
    {
        "id": 851,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "VICHAYAL"
    },
    {
        "id": 852,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "VICTOR LARCO HERRERA"
    },
    {
        "id": 853,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "17",
        "nombre": "VILCA"
    },
    {
        "id": 854,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "VILCABAMBA"
    },
    {
        "id": 855,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "VILCABAMBA"
    },
    {
        "id": 856,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "VILCAS HUAMAN"
    },
    {
        "id": 857,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "41",
        "nombre": "VILLA EL SALVADOR"
    },
    {
        "id": 858,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "32",
        "nombre": "VILLA MARIA DEL TRIUNFO"
    },
    {
        "id": 859,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "VILQUE CHICO"
    },
    {
        "id": 860,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "28",
        "nombre": "VINAC"
    },
    {
        "id": 861,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "VINCHOS"
    },
    {
        "id": 862,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "14",
        "nombre": "VIRACO"
    },
    {
        "id": 863,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "12",
        "codigoDistrito": "01",
        "nombre": "VIRU"
    },
    {
        "id": 864,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "VISTA ALEGRE"
    },
    {
        "id": 865,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "29",
        "nombre": "VITIS"
    },
    {
        "id": 866,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "YAMBRASBAMBA"
    },
    {
        "id": 867,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "YAMON"
    },
    {
        "id": 868,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "YANAC"
    },
    {
        "id": 869,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "09",
        "nombre": "YANACANCHA"
    },
    {
        "id": 870,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "YANAHUANCA"
    },
    {
        "id": 871,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "23",
        "nombre": "YANAHUARA"
    },
    {
        "id": 872,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "08",
        "nombre": "YANAMA"
    },
    {
        "id": 873,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "YANAQUIHUA"
    },
    {
        "id": 874,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "23",
        "nombre": "YANAS"
    },
    {
        "id": 875,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "19",
        "nombre": "YANQUE"
    },
    {
        "id": 876,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "YANTALO"
    },
    {
        "id": 877,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "24",
        "nombre": "YARABAMBA"
    },
    {
        "id": 878,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "YARINACOCHA"
    },
    {
        "id": 879,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "YARUMAYO"
    },
    {
        "id": 880,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "YAULI"
    },
    {
        "id": 881,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "30",
        "nombre": "YAULI"
    },
    {
        "id": 882,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "YAULI"
    },
    {
        "id": 883,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "YAURISQUE"
    },
    {
        "id": 884,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "YAUYOS"
    },
    {
        "id": 885,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "YAVARI"
    },
    {
        "id": 886,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "YONAN"
    },
    {
        "id": 887,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "YUNGA"
    },
    {
        "id": 888,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "YUNGAR"
    },
    {
        "id": 889,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "01",
        "nombre": "YUNGAY"
    },
    {
        "id": 890,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "YUNGUYO"
    },
    {
        "id": 891,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "09",
        "nombre": "YURACMARCA"
    },
    {
        "id": 892,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "YURACYACU"
    },
    {
        "id": 893,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "ZARUMILLA"
    },
    {
        "id": 894,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "ZURITE"
    },
    {
        "id": 895,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "ACCHA"
    },
    {
        "id": 896,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "ACO"
    },
    {
        "id": 897,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ACO"
    },
    {
        "id": 898,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "07",
        "nombre": "ACOBAMBA"
    },
    {
        "id": 899,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "ACOBAMBA"
    },
    {
        "id": 900,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "18",
        "codigoDistrito": "02",
        "nombre": "ACOCHACA"
    },
    {
        "id": 901,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "ACOLLA"
    },
    {
        "id": 902,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ACOPAMPA"
    },
    {
        "id": 903,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ACORA"
    },
    {
        "id": 904,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "ACOS"
    },
    {
        "id": 905,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ACOS VINCHOS"
    },
    {
        "id": 906,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "ACRAQUIA"
    },
    {
        "id": 907,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "02",
        "nombre": "ACZO"
    },
    {
        "id": 908,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "AGALLPAMPA"
    },
    {
        "id": 909,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "AGUA BLANCA"
    },
    {
        "id": 910,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "AGUAS VERDES"
    },
    {
        "id": 911,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "AHUAYCHA"
    },
    {
        "id": 912,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "AJOYANI"
    },
    {
        "id": 913,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "ALCA"
    },
    {
        "id": 914,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ALCAMENCA"
    },
    {
        "id": 915,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "02",
        "nombre": "ALFONSO UGARTE"
    },
    {
        "id": 916,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ALIS"
    },
    {
        "id": 917,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "ALTO DE LA ALIANZA"
    },
    {
        "id": 918,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ALTO NANAY"
    },
    {
        "id": 919,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "ALTO PICHIGUA"
    },
    {
        "id": 920,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ALTO TAPICHE"
    },
    {
        "id": 921,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "AMANTANI"
    },
    {
        "id": 922,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "AMARILIS"
    },
    {
        "id": 923,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "AMASHCA"
    },
    {
        "id": 924,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "AMOTAPE"
    },
    {
        "id": 925,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "ANANEA"
    },
    {
        "id": 926,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "ANAPIA"
    },
    {
        "id": 927,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "ANCAHUASI"
    },
    {
        "id": 928,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "ANCHONGA"
    },
    {
        "id": 929,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ANCO"
    },
    {
        "id": 930,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "ANDABAMBA"
    },
    {
        "id": 931,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "ANDAGUA"
    },
    {
        "id": 932,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "02",
        "nombre": "ANDAHUAYLILLAS"
    },
    {
        "id": 933,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ANDOAS"
    },
    {
        "id": 934,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "ANGUIA"
    },
    {
        "id": 935,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "ANTA"
    },
    {
        "id": 936,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ANTA"
    },
    {
        "id": 937,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "ANTAUTA"
    },
    {
        "id": 938,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "21",
        "nombre": "ANTONIO RAIMONDI"
    },
    {
        "id": 939,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "APATA"
    },
    {
        "id": 940,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "APONGO"
    },
    {
        "id": 941,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "ARAMANGO"
    },
    {
        "id": 942,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ARANCAY"
    },
    {
        "id": 943,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "ARMA"
    },
    {
        "id": 944,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "ASCOPE"
    },
    {
        "id": 945,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "ASUNCION"
    },
    {
        "id": 946,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "ATAURA"
    },
    {
        "id": 947,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "ATAVILLOS BAJO"
    },
    {
        "id": 948,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "ATE"
    },
    {
        "id": 949,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "ATIQUIPA"
    },
    {
        "id": 950,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "AUCALLAMA"
    },
    {
        "id": 951,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "AUCARA"
    },
    {
        "id": 952,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "AWAJUN"
    },
    {
        "id": 953,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "AYACUCHO"
    },
    {
        "id": 954,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "AYAHUANCO"
    },
    {
        "id": 955,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "AYAVIRI"
    },
    {
        "id": 956,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "AZANGARO"
    },
    {
        "id": 957,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "BAGUA"
    },
    {
        "id": 958,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "BALSAPUERTO"
    },
    {
        "id": 959,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "BALSAS"
    },
    {
        "id": 960,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "BANOS"
    },
    {
        "id": 961,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "BARRANCA"
    },
    {
        "id": 962,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "BELEN"
    },
    {
        "id": 963,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "BELLAVISTA"
    },
    {
        "id": 964,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "13",
        "nombre": "BOLIVAR"
    },
    {
        "id": 965,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "BOLOGNESI"
    },
    {
        "id": 966,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "BUENOS AIRES"
    },
    {
        "id": 967,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "BUENOS AIRES"
    },
    {
        "id": 968,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "CABANA"
    },
    {
        "id": 969,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "CABANA"
    },
    {
        "id": 970,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "CABANA"
    },
    {
        "id": 971,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CABANACONDE"
    },
    {
        "id": 972,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "CABANILLA"
    },
    {
        "id": 973,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "CACHIMAYO"
    },
    {
        "id": 974,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "CAHUAC"
    },
    {
        "id": 975,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "CAHUACHO"
    },
    {
        "id": 976,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "CAHUAPANAS"
    },
    {
        "id": 977,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "CAICAY"
    },
    {
        "id": 978,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "CAJA"
    },
    {
        "id": 979,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CAJACAY"
    },
    {
        "id": 980,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "CAJAY"
    },
    {
        "id": 981,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "CALAMARCA"
    },
    {
        "id": 982,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "CALAPUJA"
    },
    {
        "id": 983,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "CALLANMARCA"
    },
    {
        "id": 984,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CALLERIA"
    },
    {
        "id": 985,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "CAMILACA"
    },
    {
        "id": 986,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "CAMINACA"
    },
    {
        "id": 987,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "CAMPANILLA"
    },
    {
        "id": 988,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "CAMPORREDONDO"
    },
    {
        "id": 989,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CAMPOVERDE"
    },
    {
        "id": 990,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CANARIS"
    },
    {
        "id": 991,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CANCHAQUE"
    },
    {
        "id": 992,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CANDARAVE"
    },
    {
        "id": 993,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CANOAS DE PUNTA SAL"
    },
    {
        "id": 994,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "CAPACMARCA"
    },
    {
        "id": 995,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CAPAYA"
    },
    {
        "id": 996,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "CAPILLAS"
    },
    {
        "id": 997,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "CARABAYLLO"
    },
    {
        "id": 998,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "CARANIA"
    },
    {
        "id": 999,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CARAVELI"
    },
    {
        "id": 1000,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CARAYBAMBA"
    },
    {
        "id": 1001,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "CARAZ"
    },
    {
        "id": 1002,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "CARHUANCA"
    },
    {
        "id": 1003,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "CARHUAZ"
    },
    {
        "id": 1004,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "CARMEN ALTO"
    },
    {
        "id": 1005,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CARMEN DE LA LEGUA-REYNOSO"
    },
    {
        "id": 1006,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "02",
        "nombre": "CASCAPARA"
    },
    {
        "id": 1007,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "CASCAS"
    },
    {
        "id": 1008,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "08",
        "nombre": "CASHAPAMPA"
    },
    {
        "id": 1009,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CASITAS"
    },
    {
        "id": 1010,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "CASMA"
    },
    {
        "id": 1011,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "CASTA"
    },
    {
        "id": 1012,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "10",
        "nombre": "CATAC"
    },
    {
        "id": 1013,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CATACAOS"
    },
    {
        "id": 1014,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "CAUJUL"
    },
    {
        "id": 1015,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "CAYALTI"
    },
    {
        "id": 1016,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "CAYARA"
    },
    {
        "id": 1017,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "CAYARANI"
    },
    {
        "id": 1018,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "CAYLLOMA"
    },
    {
        "id": 1019,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CAYNA"
    },
    {
        "id": 1020,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "CCAPI"
    },
    {
        "id": 1021,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "04",
        "nombre": "CCARHUAYO"
    },
    {
        "id": 1022,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "CCOCHACCASA"
    },
    {
        "id": 1023,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CCORCA"
    },
    {
        "id": 1024,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "CELENDIN"
    },
    {
        "id": 1025,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CERRO AZUL"
    },
    {
        "id": 1026,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "CHACAPALPA"
    },
    {
        "id": 1027,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "18",
        "codigoDistrito": "01",
        "nombre": "CHACAS"
    },
    {
        "id": 1028,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "03",
        "nombre": "CHACCHO"
    },
    {
        "id": 1029,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CHACHAPOYAS"
    },
    {
        "id": 1030,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "CHACLACAYO"
    },
    {
        "id": 1031,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "CHADIN"
    },
    {
        "id": 1032,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CHALACO"
    },
    {
        "id": 1033,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "19",
        "nombre": "CHALAMARCA"
    },
    {
        "id": 1034,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "CHALCOS"
    },
    {
        "id": 1035,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CHALHUANCA"
    },
    {
        "id": 1036,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "CHAMACA"
    },
    {
        "id": 1037,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "07",
        "nombre": "CHANCAY"
    },
    {
        "id": 1038,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "CHANCAY"
    },
    {
        "id": 1039,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "CHANCHAMAYO"
    },
    {
        "id": 1040,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CHANGUILLO"
    },
    {
        "id": 1041,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "CHAPIMARCA"
    },
    {
        "id": 1042,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CHARACATO"
    },
    {
        "id": 1043,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CHAUPIMARCA"
    },
    {
        "id": 1044,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "CHAVIN"
    },
    {
        "id": 1045,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "CHAVINA"
    },
    {
        "id": 1046,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "CHAVINILLO"
    },
    {
        "id": 1047,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "CHAZUTA"
    },
    {
        "id": 1048,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "CHECCA"
    },
    {
        "id": 1049,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "CHECRAS"
    },
    {
        "id": 1050,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "CHIARA"
    },
    {
        "id": 1051,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "CHICCHE"
    },
    {
        "id": 1052,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "CHICLA"
    },
    {
        "id": 1053,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CHICLAYO"
    },
    {
        "id": 1054,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "CHIGUATA"
    },
    {
        "id": 1055,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "CHILCA"
    },
    {
        "id": 1056,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "CHILCA"
    },
    {
        "id": 1057,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "CHILCAS"
    },
    {
        "id": 1058,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "10",
        "nombre": "CHILCAYOC"
    },
    {
        "id": 1059,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "CHILETE"
    },
    {
        "id": 1060,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "CHILLIA"
    },
    {
        "id": 1061,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CHINCHAO"
    },
    {
        "id": 1062,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "CHINCHEROS"
    },
    {
        "id": 1063,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "CHINCHIHUASI"
    },
    {
        "id": 1064,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "03",
        "nombre": "CHINGALPO"
    },
    {
        "id": 1065,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "CHIPURANA"
    },
    {
        "id": 1066,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "CHIRIMOTO"
    },
    {
        "id": 1067,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CHIVAY"
    },
    {
        "id": 1068,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "CHOCO"
    },
    {
        "id": 1069,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "CHOCOPE"
    },
    {
        "id": 1070,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CHOJATA"
    },
    {
        "id": 1071,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CHONGOYAPE"
    },
    {
        "id": 1072,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CHONTABAMBA"
    },
    {
        "id": 1073,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "08",
        "nombre": "CHORAS"
    },
    {
        "id": 1074,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "18",
        "nombre": "CHOROPAMPA"
    },
    {
        "id": 1075,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "CHUGAY"
    },
    {
        "id": 1076,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "CHUGUR"
    },
    {
        "id": 1077,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "CHUMPI"
    },
    {
        "id": 1078,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "CHUPACA"
    },
    {
        "id": 1079,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "CHUPAMARCA"
    },
    {
        "id": 1080,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "CHUPURO"
    },
    {
        "id": 1081,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "CHUQUIBAMBA"
    },
    {
        "id": 1082,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "CHUQUIBAMBILLA"
    },
    {
        "id": 1083,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "CHUQUIS"
    },
    {
        "id": 1084,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "CHURCAMPA"
    },
    {
        "id": 1085,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CHURUJA"
    },
    {
        "id": 1086,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CIRCA"
    },
    {
        "id": 1087,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "CIUDAD NUEVA"
    },
    {
        "id": 1088,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "COALAQUE"
    },
    {
        "id": 1089,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "COATA"
    },
    {
        "id": 1090,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "COAYLLO"
    },
    {
        "id": 1091,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "COCABAMBA"
    },
    {
        "id": 1092,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "COCAS"
    },
    {
        "id": 1093,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "COCHABAMBA"
    },
    {
        "id": 1094,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "COCHABAMBA"
    },
    {
        "id": 1095,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "COCHABAMBA"
    },
    {
        "id": 1096,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "COCHAMAL"
    },
    {
        "id": 1097,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "codigoDistrito": "02",
        "nombre": "COCHAPETI"
    },
    {
        "id": 1098,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "COCHARCAS"
    },
    {
        "id": 1099,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "08",
        "nombre": "COISHCO"
    },
    {
        "id": 1100,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "COLCA"
    },
    {
        "id": 1101,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "COLCABAMBA"
    },
    {
        "id": 1102,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "COLCABAMBA"
    },
    {
        "id": 1103,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "09",
        "nombre": "COLONIA"
    },
    {
        "id": 1104,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "COLPAS"
    },
    {
        "id": 1105,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "COMANDANTE NOEL"
    },
    {
        "id": 1106,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "COMAS"
    },
    {
        "id": 1107,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "COMBAPATA"
    },
    {
        "id": 1108,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "CONAYCA"
    },
    {
        "id": 1109,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "CONCEPCION"
    },
    {
        "id": 1110,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "CONCHAMARCA"
    },
    {
        "id": 1111,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "CONCHUCOS"
    },
    {
        "id": 1112,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CONDORMARCA"
    },
    {
        "id": 1113,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "codigoDistrito": "05",
        "nombre": "CONDURIRI"
    },
    {
        "id": 1114,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "05",
        "nombre": "CONGAS"
    },
    {
        "id": 1115,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "COPA"
    },
    {
        "id": 1116,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "COPALLIN"
    },
    {
        "id": 1117,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "COPANI"
    },
    {
        "id": 1118,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "COPORAQUE"
    },
    {
        "id": 1119,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "COPORAQUE"
    },
    {
        "id": 1120,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "COR GREG ALBARR L.ALF UGARTE"
    },
    {
        "id": 1121,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CORANI"
    },
    {
        "id": 1122,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CORONEL CASTANEDA"
    },
    {
        "id": 1123,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "CORONGO"
    },
    {
        "id": 1124,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "COROSHA"
    },
    {
        "id": 1125,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "CORRALES"
    },
    {
        "id": 1126,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "CORTEGANA"
    },
    {
        "id": 1127,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "COTARUSE"
    },
    {
        "id": 1128,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "COYA"
    },
    {
        "id": 1129,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "CRUCERO"
    },
    {
        "id": 1130,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "CUISPES"
    },
    {
        "id": 1131,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "CUJILLO"
    },
    {
        "id": 1132,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "codigoDistrito": "05",
        "nombre": "CULEBRAS"
    },
    {
        "id": 1133,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "CULLHUAS"
    },
    {
        "id": 1134,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "CUNUMBUQUI"
    },
    {
        "id": 1135,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "CUPI"
    },
    {
        "id": 1136,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "CUPISNIQUE"
    },
    {
        "id": 1137,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "31",
        "nombre": "CURICACA"
    },
    {
        "id": 1138,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "CURIMANA"
    },
    {
        "id": 1139,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "CURPAHUASI"
    },
    {
        "id": 1140,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "CUSCA"
    },
    {
        "id": 1141,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "CUSCO"
    },
    {
        "id": 1142,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "CUTERVO"
    },
    {
        "id": 1143,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "DANIEL HERNANDEZ"
    },
    {
        "id": 1144,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "DEAN VALDIVIA"
    },
    {
        "id": 1145,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "DESAGUADERO"
    },
    {
        "id": 1146,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "35",
        "nombre": "EL AGUSTINO"
    },
    {
        "id": 1147,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "EL ALTO"
    },
    {
        "id": 1148,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "EL CENEPA"
    },
    {
        "id": 1149,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "EL ESLABON"
    },
    {
        "id": 1150,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "EL MANTARO"
    },
    {
        "id": 1151,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "02",
        "nombre": "EL ORO"
    },
    {
        "id": 1152,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "ELIAS SOPLIN"
    },
    {
        "id": 1153,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "EMILIO SAN MARTIN"
    },
    {
        "id": 1154,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "ENCANADA"
    },
    {
        "id": 1155,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "ESTIQUE"
    },
    {
        "id": 1156,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "ETEN"
    },
    {
        "id": 1157,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "FERRENAFE"
    },
    {
        "id": 1158,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "FLORENCIA DE MORA"
    },
    {
        "id": 1159,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "GORGOR"
    },
    {
        "id": 1160,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "GOYLLARISQUIZGA"
    },
    {
        "id": 1161,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "GROCIO PRADO"
    },
    {
        "id": 1162,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "GUADALUPE"
    },
    {
        "id": 1163,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "HABANA"
    },
    {
        "id": 1164,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "HAQUIRA"
    },
    {
        "id": 1165,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "03",
        "nombre": "HERMILIO VALDIZAN"
    },
    {
        "id": 1166,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "HEROINAS TOLEDO"
    },
    {
        "id": 1167,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "30",
        "nombre": "HONGOS"
    },
    {
        "id": 1168,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "HONORIA"
    },
    {
        "id": 1169,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "12",
        "nombre": "HUABAL"
    },
    {
        "id": 1170,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "09",
        "nombre": "HUACANA"
    },
    {
        "id": 1171,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "HUACASCHUQUE"
    },
    {
        "id": 1172,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "HUACAYBAMBA"
    },
    {
        "id": 1173,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "HUACCANA"
    },
    {
        "id": 1174,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "HUACHAC"
    },
    {
        "id": 1175,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "HUACHO"
    },
    {
        "id": 1176,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "HUACHOS"
    },
    {
        "id": 1177,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "30",
        "nombre": "HUACHUPAMPA"
    },
    {
        "id": 1178,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "HUACRAPUQUIO"
    },
    {
        "id": 1179,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "HUACULLANI"
    },
    {
        "id": 1180,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "25",
        "nombre": "HUALLANCA"
    },
    {
        "id": 1181,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "HUAMATAMBO"
    },
    {
        "id": 1182,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "11",
        "nombre": "HUAMPARA"
    },
    {
        "id": 1183,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "HUANCA HUANCA"
    },
    {
        "id": 1184,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "HUANCABAMBA"
    },
    {
        "id": 1185,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "HUANCANE"
    },
    {
        "id": 1186,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "HUANCAPI"
    },
    {
        "id": 1187,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "HUANCAPON"
    },
    {
        "id": 1188,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "HUANCARAMA"
    },
    {
        "id": 1189,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "HUANCASPATA"
    },
    {
        "id": 1190,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "HUANCAVELICA"
    },
    {
        "id": 1191,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "12",
        "nombre": "HUANCAYA"
    },
    {
        "id": 1192,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "HUANDOVAL"
    },
    {
        "id": 1193,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "15",
        "nombre": "HUANEC"
    },
    {
        "id": 1194,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "HUANIPACA"
    },
    {
        "id": 1195,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "HUANOQUITE"
    },
    {
        "id": 1196,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "HUANTA"
    },
    {
        "id": 1197,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "HUANUARA"
    },
    {
        "id": 1198,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "HUANUCO"
    },
    {
        "id": 1199,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "HUANUHUANU"
    },
    {
        "id": 1200,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "HUANZA"
    },
    {
        "id": 1201,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "HUAQUIRCA"
    },
    {
        "id": 1202,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "HUARANGO"
    },
    {
        "id": 1203,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "HUARAZ"
    },
    {
        "id": 1204,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "HUARI"
    },
    {
        "id": 1205,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "HUARICOLCA"
    },
    {
        "id": 1206,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "HUARIPAMPA"
    },
    {
        "id": 1207,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "HUARMACA"
    },
    {
        "id": 1208,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "07",
        "nombre": "HUARO"
    },
    {
        "id": 1209,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "HUAROS"
    },
    {
        "id": 1210,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "HUASAHUASI"
    },
    {
        "id": 1211,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "HUASICANCHA"
    },
    {
        "id": 1212,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "HUASMIN"
    },
    {
        "id": 1213,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "HUASO"
    },
    {
        "id": 1214,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "HUATA"
    },
    {
        "id": 1215,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "HUATA"
    },
    {
        "id": 1216,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "HUATASANI"
    },
    {
        "id": 1217,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "HUAURA"
    },
    {
        "id": 1218,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "HUAYA"
    },
    {
        "id": 1219,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "17",
        "nombre": "HUAYANA"
    },
    {
        "id": 1220,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "HUAYLILLAS"
    },
    {
        "id": 1221,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "HUAYLLAHUARA"
    },
    {
        "id": 1222,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "HUAYOPATA"
    },
    {
        "id": 1223,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "HUAYTARA"
    },
    {
        "id": 1224,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "HUAYUCACHI"
    },
    {
        "id": 1225,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "HUMAY"
    },
    {
        "id": 1226,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "IBERIA"
    },
    {
        "id": 1227,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "02",
        "nombre": "ICHOCAN"
    },
    {
        "id": 1228,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "ICHUNA"
    },
    {
        "id": 1229,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "IGUAIN"
    },
    {
        "id": 1230,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "IHUARI"
    },
    {
        "id": 1231,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "IHUAYLLO"
    },
    {
        "id": 1232,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "ILO"
    },
    {
        "id": 1233,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "IMAZA"
    },
    {
        "id": 1234,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "IMPERIAL"
    },
    {
        "id": 1235,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "INAMBARI"
    },
    {
        "id": 1236,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "INCHUPALLA"
    },
    {
        "id": 1237,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "INCLAN"
    },
    {
        "id": 1238,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "INDEPENDENCIA"
    },
    {
        "id": 1239,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "INDEPENDENCIA"
    },
    {
        "id": 1240,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "INDIANA"
    },
    {
        "id": 1241,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "21",
        "nombre": "INGENIO"
    },
    {
        "id": 1242,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "INGUILPATA"
    },
    {
        "id": 1243,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "IPARIA"
    },
    {
        "id": 1244,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "IQUITOS"
    },
    {
        "id": 1245,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "IRAY"
    },
    {
        "id": 1246,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "ITUATA"
    },
    {
        "id": 1247,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "JAEN"
    },
    {
        "id": 1248,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "JAMALCA"
    },
    {
        "id": 1249,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "JANJAILLO"
    },
    {
        "id": 1250,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "JAYANCA"
    },
    {
        "id": 1251,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "JEBEROS"
    },
    {
        "id": 1252,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "JENARO HERRERA"
    },
    {
        "id": 1253,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "JEQUETEPEQUE"
    },
    {
        "id": 1254,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "JESUS"
    },
    {
        "id": 1255,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "JIVIA"
    },
    {
        "id": 1256,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "JOSE CRESPO Y CASTILLO"
    },
    {
        "id": 1257,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "JOSE DOMINGO CHOQUEHUANCA"
    },
    {
        "id": 1258,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "06",
        "nombre": "JOSE SABOGAL"
    },
    {
        "id": 1259,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "JUAN GUERRA"
    },
    {
        "id": 1260,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "JULCAMARCA"
    },
    {
        "id": 1261,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "JULCAN"
    },
    {
        "id": 1262,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "JULCAN"
    },
    {
        "id": 1263,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "JUNIN"
    },
    {
        "id": 1264,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "19",
        "nombre": "KAQUIABAMBA"
    },
    {
        "id": 1265,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "KISHUARA"
    },
    {
        "id": 1266,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "LA ARENA"
    },
    {
        "id": 1267,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "21",
        "nombre": "LA BANDA DE SHILCAYO"
    },
    {
        "id": 1268,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "LA BREA"
    },
    {
        "id": 1269,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "LA CAPILLA"
    },
    {
        "id": 1270,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "05",
        "nombre": "LA COIPA"
    },
    {
        "id": 1271,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "04",
        "nombre": "LA ESPERANZA"
    },
    {
        "id": 1272,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "LA ESPERANZA"
    },
    {
        "id": 1273,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "LA FLORIDA"
    },
    {
        "id": 1274,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "LA HUACA"
    },
    {
        "id": 1275,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "LA JOYA"
    },
    {
        "id": 1276,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "LA LIBERTAD"
    },
    {
        "id": 1277,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "LA LIBERTAD DE PALLAN"
    },
    {
        "id": 1278,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "LA MATANZA"
    },
    {
        "id": 1279,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "LA MOLINA"
    },
    {
        "id": 1280,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "LA PERLA"
    },
    {
        "id": 1281,
        "codigoPais": "PER",
        "codigoDepartamento": "24",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "LA PUNTA"
    },
    {
        "id": 1282,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "LA RAMADA"
    },
    {
        "id": 1283,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "02",
        "nombre": "LA TINGUINA"
    },
    {
        "id": 1284,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "LA UNION"
    },
    {
        "id": 1285,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "LA UNION"
    },
    {
        "id": 1286,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "LA UNION"
    },
    {
        "id": 1287,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "LA VICTORIA"
    },
    {
        "id": 1288,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "LA VICTORIA"
    },
    {
        "id": 1289,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "LABERINTO"
    },
    {
        "id": 1290,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "LACABAMBA"
    },
    {
        "id": 1291,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "LACHAQUI"
    },
    {
        "id": 1292,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "LAGUNAS"
    },
    {
        "id": 1293,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "LAHUAYTAMBO"
    },
    {
        "id": 1294,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "LAJAS"
    },
    {
        "id": 1295,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "LALAQUIZ"
    },
    {
        "id": 1296,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "LAMAY"
    },
    {
        "id": 1297,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "LAMBRAMA"
    },
    {
        "id": 1298,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "LAMPA"
    },
    {
        "id": 1299,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "LARAMARCA"
    },
    {
        "id": 1300,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "LARAMATE"
    },
    {
        "id": 1301,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "31",
        "nombre": "LARAOS"
    },
    {
        "id": 1302,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "16",
        "nombre": "LARAOS"
    },
    {
        "id": 1303,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "LARES"
    },
    {
        "id": 1304,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "LARI"
    },
    {
        "id": 1305,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "LARIA"
    },
    {
        "id": 1306,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "LAS AMAZONAS"
    },
    {
        "id": 1307,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "01",
        "codigoDistrito": "03",
        "nombre": "LAS PIEDRAS"
    },
    {
        "id": 1308,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "LIMBANI"
    },
    {
        "id": 1309,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "LLALLI"
    },
    {
        "id": 1310,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "LLAMA"
    },
    {
        "id": 1311,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "LLAMA"
    },
    {
        "id": 1312,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "LLAPO"
    },
    {
        "id": 1313,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "06",
        "nombre": "LLIPA"
    },
    {
        "id": 1314,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "codigoDistrito": "02",
        "nombre": "LLIPATA"
    },
    {
        "id": 1315,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "13",
        "nombre": "LLOCLLAPAMPA"
    },
    {
        "id": 1316,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "LLOQUE"
    },
    {
        "id": 1317,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "LLUMPA"
    },
    {
        "id": 1318,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "LOCROJA"
    },
    {
        "id": 1319,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "LONGOTEA"
    },
    {
        "id": 1320,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "LONGUITA"
    },
    {
        "id": 1321,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "LONYA CHICO"
    },
    {
        "id": 1322,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "LONYA GRANDE"
    },
    {
        "id": 1323,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "LOS BANOS DEL INCA"
    },
    {
        "id": 1324,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "LOS MOROCHUCOS"
    },
    {
        "id": 1325,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "LUCMA"
    },
    {
        "id": 1326,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "LUCRE"
    },
    {
        "id": 1327,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "08",
        "nombre": "LUCRE"
    },
    {
        "id": 1328,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "LUIS CARRANZA"
    },
    {
        "id": 1329,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "LUNAHUANA"
    },
    {
        "id": 1330,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "LURIGANCHO"
    },
    {
        "id": 1331,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "LUYA"
    },
    {
        "id": 1332,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "LUYA VIEJO"
    },
    {
        "id": 1333,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "MACARI"
    },
    {
        "id": 1334,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "03",
        "nombre": "MACATE"
    },
    {
        "id": 1335,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "13",
        "nombre": "MACHE"
    },
    {
        "id": 1336,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "MACUSANI"
    },
    {
        "id": 1337,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "MAGDALENA DE CAO"
    },
    {
        "id": 1338,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "19",
        "codigoDistrito": "04",
        "nombre": "MALVAS"
    },
    {
        "id": 1339,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "MANANTAY"
    },
    {
        "id": 1340,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "MANAZO"
    },
    {
        "id": 1341,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "03",
        "nombre": "MANCOS"
    },
    {
        "id": 1342,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "MANZANARES"
    },
    {
        "id": 1343,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "MARA"
    },
    {
        "id": 1344,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "MARANGANI"
    },
    {
        "id": 1345,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "05",
        "nombre": "MARAS"
    },
    {
        "id": 1346,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "04",
        "nombre": "MARCA"
    },
    {
        "id": 1347,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "MARCABAL"
    },
    {
        "id": 1348,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "MARCABAMBA"
    },
    {
        "id": 1349,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "09",
        "nombre": "MARCAPATA"
    },
    {
        "id": 1350,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "MARCARA"
    },
    {
        "id": 1351,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "MARCAS"
    },
    {
        "id": 1352,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "04",
        "nombre": "MARCAVELICA"
    },
    {
        "id": 1353,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "MARGOS"
    },
    {
        "id": 1354,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "MARIA PARADO DE BELLIDO"
    },
    {
        "id": 1355,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "MARIANO DAMASO BERAUN"
    },
    {
        "id": 1356,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "26",
        "nombre": "MARIANO MELGAR"
    },
    {
        "id": 1357,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "MARIANO N VALCARCEL"
    },
    {
        "id": 1358,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "MARIATANA"
    },
    {
        "id": 1359,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "MARISCAL CASTILLA"
    },
    {
        "id": 1360,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "MARISCAL GAMARRA"
    },
    {
        "id": 1361,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "11",
        "codigoDistrito": "03",
        "nombre": "MARMOT"
    },
    {
        "id": 1362,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "32",
        "nombre": "MASMA CHICCHE"
    },
    {
        "id": 1363,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "04",
        "nombre": "MATACOTO"
    },
    {
        "id": 1364,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "MATALAQUE"
    },
    {
        "id": 1365,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "MATAPALO"
    },
    {
        "id": 1366,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "05",
        "nombre": "MATO"
    },
    {
        "id": 1367,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "MATUCANA"
    },
    {
        "id": 1368,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "MAZAMARI"
    },
    {
        "id": 1369,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "MAZAN"
    },
    {
        "id": 1370,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "MCAL CASTILLA"
    },
    {
        "id": 1371,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "MIGUEL CHECA"
    },
    {
        "id": 1372,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "MILPUC"
    },
    {
        "id": 1373,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "MIRACOSTA"
    },
    {
        "id": 1374,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "18",
        "nombre": "MIRAFLORES"
    },
    {
        "id": 1375,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "05",
        "nombre": "MIRGAS"
    },
    {
        "id": 1376,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "MITO"
    },
    {
        "id": 1377,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "MOCHE"
    },
    {
        "id": 1378,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "MOCHUMI"
    },
    {
        "id": 1379,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "07",
        "codigoDistrito": "04",
        "nombre": "MOLINO"
    },
    {
        "id": 1380,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "MOLINOPAMPA"
    },
    {
        "id": 1381,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "16",
        "nombre": "MOLINOS"
    },
    {
        "id": 1382,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "MOLLENDO"
    },
    {
        "id": 1383,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "MOLLEPATA"
    },
    {
        "id": 1384,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "MONSEFU"
    },
    {
        "id": 1385,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "MONTERO"
    },
    {
        "id": 1386,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "MOQUEGUA"
    },
    {
        "id": 1387,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "MORALES"
    },
    {
        "id": 1388,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "04",
        "nombre": "MORO"
    },
    {
        "id": 1389,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "MOROCOCHA"
    },
    {
        "id": 1390,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "MUNANI"
    },
    {
        "id": 1391,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "18",
        "nombre": "MUQUI"
    },
    {
        "id": 1392,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "15",
        "nombre": "NAHUIMPUQUIO"
    },
    {
        "id": 1393,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "NANCHOC"
    },
    {
        "id": 1394,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "NAPO"
    },
    {
        "id": 1395,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "02",
        "nombre": "NAVAN"
    },
    {
        "id": 1396,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "NIEPOS"
    },
    {
        "id": 1397,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "NINABAMBA"
    },
    {
        "id": 1398,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "NUEVA ARICA"
    },
    {
        "id": 1399,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "NUEVA REQUENA"
    },
    {
        "id": 1400,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "12",
        "nombre": "NUEVE DE JULIO"
    },
    {
        "id": 1401,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "09",
        "nombre": "NUEVO CHIMBOTE"
    },
    {
        "id": 1402,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "NUEVO IMPERIAL"
    },
    {
        "id": 1403,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "11",
        "codigoDistrito": "06",
        "nombre": "OBAS"
    },
    {
        "id": 1404,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "16",
        "nombre": "OCANA"
    },
    {
        "id": 1405,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "03",
        "nombre": "OCOBAMBA"
    },
    {
        "id": 1406,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "OCOBAMBA"
    },
    {
        "id": 1407,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "OCORURO"
    },
    {
        "id": 1408,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "07",
        "nombre": "OCROS"
    },
    {
        "id": 1409,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "13",
        "nombre": "OCUMAL"
    },
    {
        "id": 1410,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "OLLACHEA"
    },
    {
        "id": 1411,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "OLMOS"
    },
    {
        "id": 1412,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "OMACHA"
    },
    {
        "id": 1413,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "OMATE"
    },
    {
        "id": 1414,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "OMIA"
    },
    {
        "id": 1415,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "04",
        "codigoDistrito": "03",
        "nombre": "ONDORES"
    },
    {
        "id": 1416,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "ONGON"
    },
    {
        "id": 1417,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "09",
        "nombre": "ORCOPAMPA"
    },
    {
        "id": 1418,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "13",
        "nombre": "ORCOTUNA"
    },
    {
        "id": 1419,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "11",
        "nombre": "OROPESA"
    },
    {
        "id": 1420,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "ORURILLO"
    },
    {
        "id": 1421,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "17",
        "nombre": "OTOCA"
    },
    {
        "id": 1422,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "OTUZCO"
    },
    {
        "id": 1423,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "OXAMARCA"
    },
    {
        "id": 1424,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "01",
        "nombre": "OXAPAMPA"
    },
    {
        "id": 1425,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "OYOLO"
    },
    {
        "id": 1426,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "OYON"
    },
    {
        "id": 1427,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "PACAIPAMPA"
    },
    {
        "id": 1428,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "PACANGA"
    },
    {
        "id": 1429,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "PACARAN"
    },
    {
        "id": 1430,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "PACASMAYO"
    },
    {
        "id": 1431,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "PACCHA"
    },
    {
        "id": 1432,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "PACCHA"
    },
    {
        "id": 1433,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "PACHACONAS"
    },
    {
        "id": 1434,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "PACHACUTEC"
    },
    {
        "id": 1435,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "10",
        "nombre": "PACHAMARCA"
    },
    {
        "id": 1436,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "PACHANGARA"
    },
    {
        "id": 1437,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "04",
        "codigoDistrito": "04",
        "nombre": "PACHIZA"
    },
    {
        "id": 1438,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "PACOBAMBA"
    },
    {
        "id": 1439,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "PACORA"
    },
    {
        "id": 1440,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "PADRE MARQUEZ"
    },
    {
        "id": 1441,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "05",
        "nombre": "PAICO"
    },
    {
        "id": 1442,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "PAITA"
    },
    {
        "id": 1443,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "15",
        "nombre": "PALCA"
    },
    {
        "id": 1444,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "PALCA"
    },
    {
        "id": 1445,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "PALCAMAYO"
    },
    {
        "id": 1446,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "PALLANCHACRA"
    },
    {
        "id": 1447,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "08",
        "nombre": "PALLASCA"
    },
    {
        "id": 1448,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "PALLPATA"
    },
    {
        "id": 1449,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "04",
        "nombre": "PAMPA HERMOZA"
    },
    {
        "id": 1450,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "PAMPAMARCA"
    },
    {
        "id": 1451,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "PAMPAROMAS"
    },
    {
        "id": 1452,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "PAMPAS"
    },
    {
        "id": 1453,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "05",
        "nombre": "PAMPAS CHICO"
    },
    {
        "id": 1454,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "PAMPAS DE HOSPITAL"
    },
    {
        "id": 1455,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "PANAO"
    },
    {
        "id": 1456,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "PANGOA"
    },
    {
        "id": 1457,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "PAPAPLAYA"
    },
    {
        "id": 1458,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "PAPAYAL"
    },
    {
        "id": 1459,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "PARACAS"
    },
    {
        "id": 1460,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "PARARCA"
    },
    {
        "id": 1461,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "PARATIA"
    },
    {
        "id": 1462,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "PARCONA"
    },
    {
        "id": 1463,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "PARDO MIGUEL"
    },
    {
        "id": 1464,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "PASTAZA"
    },
    {
        "id": 1465,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "17",
        "nombre": "PATAPO"
    },
    {
        "id": 1466,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "09",
        "codigoDistrito": "03",
        "nombre": "PATIVILCA"
    },
    {
        "id": 1467,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "PAUCAR"
    },
    {
        "id": 1468,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "PAUCARA"
    },
    {
        "id": 1469,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "PAUCARBAMBA"
    },
    {
        "id": 1470,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "PAUCARCOLLA"
    },
    {
        "id": 1471,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "PAUCARTAMBO"
    },
    {
        "id": 1472,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "09",
        "nombre": "PAUCAS"
    },
    {
        "id": 1473,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "06",
        "codigoDistrito": "02",
        "nombre": "PEBAS"
    },
    {
        "id": 1474,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "12",
        "codigoDistrito": "01",
        "nombre": "PEDRO GALVEZ"
    },
    {
        "id": 1475,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "codigoDistrito": "02",
        "nombre": "PEDRO VILCA APAZA"
    },
    {
        "id": 1476,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PERENE"
    },
    {
        "id": 1477,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "PHARA"
    },
    {
        "id": 1478,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "PICHACANI"
    },
    {
        "id": 1479,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PICHIGUA"
    },
    {
        "id": 1480,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "PICOTA"
    },
    {
        "id": 1481,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "01",
        "codigoDistrito": "16",
        "nombre": "PILCHACA"
    },
    {
        "id": 1482,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "23",
        "nombre": "PILCOMAYO"
    },
    {
        "id": 1483,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "12",
        "codigoDistrito": "02",
        "nombre": "PILCUYO"
    },
    {
        "id": 1484,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "10",
        "codigoDistrito": "09",
        "nombre": "PILLPINTO"
    },
    {
        "id": 1485,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "PIMPINGOS"
    },
    {
        "id": 1486,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "PINTO RECODO"
    },
    {
        "id": 1487,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "13",
        "nombre": "PION"
    },
    {
        "id": 1488,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "PISAC"
    },
    {
        "id": 1489,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "PISACOMA"
    },
    {
        "id": 1490,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "PISCOBAMBA"
    },
    {
        "id": 1491,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "PISCOYACU"
    },
    {
        "id": 1492,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "05",
        "nombre": "PITUMARCA"
    },
    {
        "id": 1493,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "PLATERIA"
    },
    {
        "id": 1494,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "09",
        "nombre": "POCOHUANCA"
    },
    {
        "id": 1495,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "POCOLLAY"
    },
    {
        "id": 1496,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "POCSI"
    },
    {
        "id": 1497,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "POLOBAYA"
    },
    {
        "id": 1498,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "POMABAMBA"
    },
    {
        "id": 1499,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "POMACANCHI"
    },
    {
        "id": 1500,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "14",
        "nombre": "POMACOCHA"
    },
    {
        "id": 1501,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "POMACOCHA"
    },
    {
        "id": 1502,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "POMAHUACA"
    },
    {
        "id": 1503,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "10",
        "nombre": "PONTO"
    },
    {
        "id": 1504,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "POROTO"
    },
    {
        "id": 1505,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "POTONI"
    },
    {
        "id": 1506,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "05",
        "nombre": "PUCACACA"
    },
    {
        "id": 1507,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "PUCUSANA"
    },
    {
        "id": 1508,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "03",
        "codigoDistrito": "06",
        "nombre": "PUCYURA"
    },
    {
        "id": 1509,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "PUEBLO LIBRE"
    },
    {
        "id": 1510,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "17",
        "nombre": "PUEBLO LIBRE"
    },
    {
        "id": 1511,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "PUEBLO NUEVO"
    },
    {
        "id": 1512,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "PUEBLO NUEVO"
    },
    {
        "id": 1513,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "PUEBLO NUEVO DE COLAN"
    },
    {
        "id": 1514,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "PUERTO INCA"
    },
    {
        "id": 1515,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "PUNCHANA"
    },
    {
        "id": 1516,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "PUNO"
    },
    {
        "id": 1517,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "PUNOS"
    },
    {
        "id": 1518,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "PUNTA DE BOMBON"
    },
    {
        "id": 1519,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "21",
        "nombre": "PUNTA NEGRA"
    },
    {
        "id": 1520,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "PUQUINA"
    },
    {
        "id": 1521,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "PUQUIO"
    },
    {
        "id": 1522,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "PUSI"
    },
    {
        "id": 1523,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "PUTINA"
    },
    {
        "id": 1524,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "PUYCA"
    },
    {
        "id": 1525,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "QUECHUALLA"
    },
    {
        "id": 1526,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "QUELLOUNO"
    },
    {
        "id": 1527,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "QUERCO"
    },
    {
        "id": 1528,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "QUEROCOTILLO"
    },
    {
        "id": 1529,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "14",
        "nombre": "QUEROCOTO"
    },
    {
        "id": 1530,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "04",
        "nombre": "QUEROPALCA"
    },
    {
        "id": 1531,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "05",
        "nombre": "QUICHES"
    },
    {
        "id": 1532,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "QUILAHUANI"
    },
    {
        "id": 1533,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "QUILCA"
    },
    {
        "id": 1534,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "26",
        "nombre": "QUILCAS"
    },
    {
        "id": 1535,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "15",
        "codigoDistrito": "05",
        "nombre": "QUILLO"
    },
    {
        "id": 1536,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "20",
        "nombre": "QUINCHES"
    },
    {
        "id": 1537,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "17",
        "nombre": "QUINJALCA"
    },
    {
        "id": 1538,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "QUINOTA"
    },
    {
        "id": 1539,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "QUINUABAMBA"
    },
    {
        "id": 1540,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "12",
        "codigoDistrito": "12",
        "nombre": "QUIQUIJANA"
    },
    {
        "id": 1541,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "QUITO ARMA"
    },
    {
        "id": 1542,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "16",
        "nombre": "QUIVILLA"
    },
    {
        "id": 1543,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "09",
        "nombre": "RAGASH"
    },
    {
        "id": 1544,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "RAZURI"
    },
    {
        "id": 1545,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "01",
        "nombre": "RECUAY"
    },
    {
        "id": 1546,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "REQUE"
    },
    {
        "id": 1547,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "REQUENA"
    },
    {
        "id": 1548,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "13",
        "nombre": "RICARDO PALMA"
    },
    {
        "id": 1549,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "25",
        "nombre": "RICRAN"
    },
    {
        "id": 1550,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "22",
        "nombre": "RIMAC"
    },
    {
        "id": 1551,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "06",
        "nombre": "RINCONADA LLICUAR"
    },
    {
        "id": 1552,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "RIO GRANDE"
    },
    {
        "id": 1553,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "RIOJA"
    },
    {
        "id": 1554,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "RONDOCAN"
    },
    {
        "id": 1555,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "06",
        "nombre": "RONDOS"
    },
    {
        "id": 1556,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "05",
        "codigoDistrito": "07",
        "nombre": "ROSASPATA"
    },
    {
        "id": 1557,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "RUMISAPA"
    },
    {
        "id": 1558,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "RUPA RUPA"
    },
    {
        "id": 1559,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "SABAINO"
    },
    {
        "id": 1560,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "SABANDIA"
    },
    {
        "id": 1561,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "03",
        "nombre": "SACANCHE"
    },
    {
        "id": 1562,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "08",
        "codigoDistrito": "02",
        "nombre": "SACSAMARCA"
    },
    {
        "id": 1563,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "SALAMANCA"
    },
    {
        "id": 1564,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SALAS"
    },
    {
        "id": 1565,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "SALAS"
    },
    {
        "id": 1566,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "SALAVERRY"
    },
    {
        "id": 1567,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "19",
        "nombre": "SALCABAMBA"
    },
    {
        "id": 1568,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "26",
        "nombre": "SALCAHUASI"
    },
    {
        "id": 1569,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "SALITRAL"
    },
    {
        "id": 1570,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "SALITRAL"
    },
    {
        "id": 1571,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "SALPO"
    },
    {
        "id": 1572,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "12",
        "nombre": "SAMAN"
    },
    {
        "id": 1573,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "13",
        "codigoDistrito": "06",
        "nombre": "SAMANCO"
    },
    {
        "id": 1574,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "06",
        "nombre": "SAMEGUA"
    },
    {
        "id": 1575,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "SAMUEL PASTOR"
    },
    {
        "id": 1576,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "27",
        "nombre": "SAN AGUSTIN"
    },
    {
        "id": 1577,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "08",
        "nombre": "SAN ANDRES DE CUTERVO"
    },
    {
        "id": 1578,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "14",
        "nombre": "SAN ANDRES DE TUPICOCHA"
    },
    {
        "id": 1579,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "13",
        "nombre": "SAN ANTON"
    },
    {
        "id": 1580,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "09",
        "nombre": "SAN ANTONIO"
    },
    {
        "id": 1581,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "12",
        "nombre": "SAN ANTONIO"
    },
    {
        "id": 1582,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "16",
        "nombre": "SAN ANTONIO"
    },
    {
        "id": 1583,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "SAN ANTONIO DE ANTAPARCO"
    },
    {
        "id": 1584,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "SAN ANTONIO DE CACHI"
    },
    {
        "id": 1585,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "SAN ANTONIO DE CUSICANCHA"
    },
    {
        "id": 1586,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "16",
        "nombre": "SAN BARTOLOME"
    },
    {
        "id": 1587,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "05",
        "nombre": "SAN BENITO"
    },
    {
        "id": 1588,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "40",
        "nombre": "SAN BORJA"
    },
    {
        "id": 1589,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "SAN BUENAVENTURA"
    },
    {
        "id": 1590,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "08",
        "nombre": "SAN CARLOS"
    },
    {
        "id": 1591,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "SAN CLEMENTE"
    },
    {
        "id": 1592,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "32",
        "nombre": "SAN CRISTOBAL"
    },
    {
        "id": 1593,
        "codigoPais": "PER",
        "codigoDepartamento": "17",
        "codigoProvincia": "01",
        "codigoDistrito": "04",
        "nombre": "SAN CRISTOBAL"
    },
    {
        "id": 1594,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "SAN CRISTOBAL"
    },
    {
        "id": 1595,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "SAN FCO DE ASIS DE YARUSYACAN"
    },
    {
        "id": 1596,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "SAN FCO DE DAGUAS"
    },
    {
        "id": 1597,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "08",
        "nombre": "SAN FELIPE"
    },
    {
        "id": 1598,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "SAN FRANCISCO"
    },
    {
        "id": 1599,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "SAN FRANCISCO DE ASIS"
    },
    {
        "id": 1600,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "SAN FRANCISCO DE SANGAYAICO"
    },
    {
        "id": 1601,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "01",
        "nombre": "SAN IGNACIO"
    },
    {
        "id": 1602,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "SAN ISIDRO"
    },
    {
        "id": 1603,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "19",
        "nombre": "SAN ISIDRO DE MAINO"
    },
    {
        "id": 1604,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "10",
        "codigoDistrito": "08",
        "nombre": "SAN JAVIER DE ALPABAMBA"
    },
    {
        "id": 1605,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "22",
        "nombre": "SAN JOAQUIN"
    },
    {
        "id": 1606,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "14",
        "nombre": "SAN JOSE"
    },
    {
        "id": 1607,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "SAN JOSE DE LOS MOLINOS"
    },
    {
        "id": 1608,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "15",
        "nombre": "SAN JOSE DE QUERO"
    },
    {
        "id": 1609,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "10",
        "nombre": "SAN JUAN"
    },
    {
        "id": 1610,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "21",
        "nombre": "SAN JUAN"
    },
    {
        "id": 1611,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "22",
        "nombre": "SAN JUAN"
    },
    {
        "id": 1612,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "SAN JUAN BAUTISTA"
    },
    {
        "id": 1613,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "16",
        "nombre": "SAN JUAN DE CHACNA"
    },
    {
        "id": 1614,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "32",
        "nombre": "SAN JUAN DE IRIS"
    },
    {
        "id": 1615,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "SAN JUAN DE ISCOS"
    },
    {
        "id": 1616,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "18",
        "nombre": "SAN JUAN DE LOPECANCHA"
    },
    {
        "id": 1617,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "37",
        "nombre": "SAN JUAN DE LURIGANCHO"
    },
    {
        "id": 1618,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "36",
        "nombre": "SAN JUAN DE MIRAFLORES"
    },
    {
        "id": 1619,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "16",
        "codigoDistrito": "06",
        "nombre": "SAN JUAN DE RONTOY"
    },
    {
        "id": 1620,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "19",
        "nombre": "SAN JUAN DE TANTARANCHE"
    },
    {
        "id": 1621,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "26",
        "nombre": "SAN LORENZO"
    },
    {
        "id": 1622,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "20",
        "nombre": "SAN LORENZO DE QUINTI"
    },
    {
        "id": 1623,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "17",
        "codigoDistrito": "01",
        "nombre": "SAN LUIS"
    },
    {
        "id": 1624,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "38",
        "nombre": "SAN LUIS"
    },
    {
        "id": 1625,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "13",
        "nombre": "SAN LUIS"
    },
    {
        "id": 1626,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "SAN LUIS DE SHUARO"
    },
    {
        "id": 1627,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "13",
        "nombre": "SAN MARCOS"
    },
    {
        "id": 1628,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "26",
        "nombre": "SAN MARTIN DE PORRES"
    },
    {
        "id": 1629,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "22",
        "nombre": "SAN MATEO DE OTAO"
    },
    {
        "id": 1630,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "01",
        "nombre": "SAN MIGUEL"
    },
    {
        "id": 1631,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "27",
        "nombre": "SAN MIGUEL"
    },
    {
        "id": 1632,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "10",
        "codigoDistrito": "05",
        "nombre": "SAN MIGUEL DE CAURI"
    },
    {
        "id": 1633,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "18",
        "nombre": "SAN MIGUEL DE CHACCRAMPA"
    },
    {
        "id": 1634,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "03",
        "codigoDistrito": "17",
        "nombre": "SAN MIGUEL DE CORPANQUI"
    },
    {
        "id": 1635,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "SAN MIGUEL DE EL FAIQUE"
    },
    {
        "id": 1636,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "06",
        "nombre": "SAN PABLO"
    },
    {
        "id": 1637,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "20",
        "codigoDistrito": "09",
        "nombre": "SAN PEDRO"
    },
    {
        "id": 1638,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "SAN PEDRO"
    },
    {
        "id": 1639,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "SAN PEDRO DE CACHORA"
    },
    {
        "id": 1640,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "27",
        "nombre": "SAN PEDRO DE CHUNAN"
    },
    {
        "id": 1641,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "07",
        "codigoDistrito": "09",
        "nombre": "SAN PEDRO DE CORIS"
    },
    {
        "id": 1642,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "SAN PEDRO DE HUACARPANA"
    },
    {
        "id": 1643,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "23",
        "nombre": "SAN PEDRO DE HUANCAYRE"
    },
    {
        "id": 1644,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "07",
        "nombre": "SAN PEDRO DE LARCAY"
    },
    {
        "id": 1645,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "31",
        "nombre": "SAN PEDRO DE PALCO"
    },
    {
        "id": 1646,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "23",
        "nombre": "SAN PEDRO DE PILAS"
    },
    {
        "id": 1647,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "05",
        "nombre": "SAN PEDRO DE PILLAO"
    },
    {
        "id": 1648,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "12",
        "nombre": "SAN PEDRO DE PUTINA PUNCO"
    },
    {
        "id": 1649,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "SAN RAFAEL"
    },
    {
        "id": 1650,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "07",
        "codigoDistrito": "02",
        "nombre": "SAN RAFAEL"
    },
    {
        "id": 1651,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "16",
        "nombre": "SAN ROQUE DE CUMBAZA"
    },
    {
        "id": 1652,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "SAN SALVADOR"
    },
    {
        "id": 1653,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "11",
        "codigoDistrito": "04",
        "nombre": "SAN SALVADOR DE QUIJE"
    },
    {
        "id": 1654,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "SAN SEBASTIAN"
    },
    {
        "id": 1655,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "01",
        "nombre": "SAN VICENTE DE CANETE"
    },
    {
        "id": 1656,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "SANDIA"
    },
    {
        "id": 1657,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "SANGARARA"
    },
    {
        "id": 1658,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "32",
        "nombre": "SANO"
    },
    {
        "id": 1659,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "SANTA ANA"
    },
    {
        "id": 1660,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "29",
        "nombre": "SANTA ANA"
    },
    {
        "id": 1661,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "SANTA ANA DE TUSI"
    },
    {
        "id": 1662,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "43",
        "nombre": "SANTA ANITA"
    },
    {
        "id": 1663,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "SANTA CATALINA DE MOSSA"
    },
    {
        "id": 1664,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 1665,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 1666,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "01",
        "nombre": "SANTA CRUZ"
    },
    {
        "id": 1667,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "24",
        "nombre": "SANTA CRUZ DE COCACHACRA"
    },
    {
        "id": 1668,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "14",
        "nombre": "SANTA CRUZ DE FLORES"
    },
    {
        "id": 1669,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "17",
        "nombre": "SANTA ISABEL DE SIGUAS"
    },
    {
        "id": 1670,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "25",
        "nombre": "SANTA LUCIA"
    },
    {
        "id": 1671,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "10",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1672,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "10",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1673,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "13",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1674,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1675,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "08",
        "codigoDistrito": "10",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1676,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "01",
        "codigoDistrito": "29",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1677,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "SANTA ROSA"
    },
    {
        "id": 1678,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "09",
        "codigoDistrito": "06",
        "nombre": "SANTA TERESA"
    },
    {
        "id": 1679,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "07",
        "codigoDistrito": "01",
        "nombre": "SANTIAGO DE CHUCO"
    },
    {
        "id": 1680,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "SANTIAGO DE PISCHA"
    },
    {
        "id": 1681,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "06",
        "codigoDistrito": "14",
        "nombre": "SANTIAGO DE QUIRAHUARA"
    },
    {
        "id": 1682,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "SANTILLANA"
    },
    {
        "id": 1683,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "07",
        "nombre": "SANTO DOMINGO"
    },
    {
        "id": 1684,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "12",
        "nombre": "SANTO DOMINGO DE LA CAPILLA"
    },
    {
        "id": 1685,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "06",
        "codigoDistrito": "28",
        "nombre": "SANTO DOMINGO DE LOS OLLEROS"
    },
    {
        "id": 1686,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "20",
        "nombre": "SANTO TOMAS"
    },
    {
        "id": 1687,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "13",
        "nombre": "SANTO TOMAS"
    },
    {
        "id": 1688,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "SARAYACU"
    },
    {
        "id": 1689,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "13",
        "nombre": "SARHUA"
    },
    {
        "id": 1690,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "03",
        "codigoDistrito": "07",
        "nombre": "SARIN"
    },
    {
        "id": 1691,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "06",
        "codigoDistrito": "19",
        "nombre": "SAUCE"
    },
    {
        "id": 1692,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "11",
        "nombre": "SAUCEPAMPA"
    },
    {
        "id": 1693,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "07",
        "nombre": "SAURAMA"
    },
    {
        "id": 1694,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "33",
        "nombre": "SAUSA"
    },
    {
        "id": 1695,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "07",
        "nombre": "SAYLLA"
    },
    {
        "id": 1696,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "08",
        "codigoDistrito": "01",
        "nombre": "SECHURA"
    },
    {
        "id": 1697,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "10",
        "nombre": "SHAMBOYACU"
    },
    {
        "id": 1698,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "SHANAO"
    },
    {
        "id": 1699,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "10",
        "codigoDistrito": "03",
        "nombre": "SHATOJA"
    },
    {
        "id": 1700,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "SHILLA"
    },
    {
        "id": 1701,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "SHIPASBAMBA"
    },
    {
        "id": 1702,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "03",
        "codigoDistrito": "21",
        "nombre": "SHUNQUI"
    },
    {
        "id": 1703,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "15",
        "nombre": "SIBAYO"
    },
    {
        "id": 1704,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "SICCHEZ"
    },
    {
        "id": 1705,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "06",
        "codigoDistrito": "01",
        "nombre": "SICUANI"
    },
    {
        "id": 1706,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "14",
        "codigoDistrito": "01",
        "nombre": "SIHUAS"
    },
    {
        "id": 1707,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "SIMON BOLIVAR"
    },
    {
        "id": 1708,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "28",
        "nombre": "SINCOS"
    },
    {
        "id": 1709,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "10",
        "nombre": "SITAJARA"
    },
    {
        "id": 1710,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "01",
        "codigoDistrito": "12",
        "nombre": "SOCOS"
    },
    {
        "id": 1711,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "SOLOCO"
    },
    {
        "id": 1712,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "01",
        "codigoDistrito": "21",
        "nombre": "SONCHE"
    },
    {
        "id": 1713,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "SONDOR"
    },
    {
        "id": 1714,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "SONDORILLO"
    },
    {
        "id": 1715,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "SORAYA"
    },
    {
        "id": 1716,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "01",
        "codigoDistrito": "05",
        "nombre": "SORITOR"
    },
    {
        "id": 1717,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "03",
        "codigoDistrito": "09",
        "nombre": "SOROCHUCO"
    },
    {
        "id": 1718,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "05",
        "codigoDistrito": "24",
        "nombre": "STA ANA DE HUAYCAHUACHO"
    },
    {
        "id": 1719,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "STA BARBARA DE CARHUACAYAN"
    },
    {
        "id": 1720,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "11",
        "nombre": "STA CRUZ DE ANDAMARCA"
    },
    {
        "id": 1721,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "STA CRUZ DE TOLEDO"
    },
    {
        "id": 1722,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "15",
        "nombre": "STA MARIA DE CHICMO"
    },
    {
        "id": 1723,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "18",
        "nombre": "STA RITA DE SIGUAS"
    },
    {
        "id": 1724,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "02",
        "codigoDistrito": "14",
        "nombre": "STA ROSA DE OCOPA"
    },
    {
        "id": 1725,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "STA ROSA DE SACCO"
    },
    {
        "id": 1726,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "02",
        "codigoDistrito": "16",
        "nombre": "STGO DE PUPUJA"
    },
    {
        "id": 1727,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "10",
        "nombre": "SUBTANJALLA"
    },
    {
        "id": 1728,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "SUCCHA"
    },
    {
        "id": 1729,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "06",
        "codigoDistrito": "08",
        "nombre": "SUITUCANCHA"
    },
    {
        "id": 1730,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "12",
        "nombre": "SUMBILCA"
    },
    {
        "id": 1731,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "07",
        "nombre": "SUNAMPE"
    },
    {
        "id": 1732,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "23",
        "nombre": "SURCUBAMBA"
    },
    {
        "id": 1733,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "11",
        "nombre": "SUSAPAYA"
    },
    {
        "id": 1734,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "08",
        "codigoDistrito": "07",
        "nombre": "SUYKUTAMBO"
    },
    {
        "id": 1735,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "SUYO"
    },
    {
        "id": 1736,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "11",
        "codigoDistrito": "07",
        "nombre": "TABACONAS"
    },
    {
        "id": 1737,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "03",
        "codigoDistrito": "02",
        "nombre": "TAHUANIA"
    },
    {
        "id": 1738,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "11",
        "nombre": "TALAVERA"
    },
    {
        "id": 1739,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "05",
        "codigoDistrito": "06",
        "nombre": "TAMARINDO"
    },
    {
        "id": 1740,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "04",
        "codigoDistrito": "06",
        "nombre": "TAMBO"
    },
    {
        "id": 1741,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "TAMBO DE MORA"
    },
    {
        "id": 1742,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "TAMBO GRANDE"
    },
    {
        "id": 1743,
        "codigoPais": "PER",
        "codigoDepartamento": "16",
        "codigoProvincia": "01",
        "codigoDistrito": "01",
        "nombre": "TAMBOPATA"
    },
    {
        "id": 1744,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "01",
        "codigoDistrito": "09",
        "nombre": "TAMBURCO"
    },
    {
        "id": 1745,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "12",
        "nombre": "TAPAIRIHUA"
    },
    {
        "id": 1746,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "02",
        "codigoDistrito": "16",
        "nombre": "TAPAY"
    },
    {
        "id": 1747,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "TAPICHE"
    },
    {
        "id": 1748,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "10",
        "codigoDistrito": "11",
        "nombre": "TAUCA"
    },
    {
        "id": 1749,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "09",
        "nombre": "TAURIA"
    },
    {
        "id": 1750,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "25",
        "nombre": "TAURIPAMPA"
    },
    {
        "id": 1751,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "20",
        "nombre": "TIABAYA"
    },
    {
        "id": 1752,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "TIBILLO"
    },
    {
        "id": 1753,
        "codigoPais": "PER",
        "codigoDepartamento": "22",
        "codigoProvincia": "02",
        "codigoDistrito": "13",
        "nombre": "TICACO"
    },
    {
        "id": 1754,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "12",
        "codigoDistrito": "08",
        "nombre": "TICAPAMPA"
    },
    {
        "id": 1755,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "04",
        "codigoDistrito": "28",
        "nombre": "TICRAPO"
    },
    {
        "id": 1756,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "TIGRE"
    },
    {
        "id": 1757,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "13",
        "codigoDistrito": "03",
        "nombre": "TILALI"
    },
    {
        "id": 1758,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "TINCO"
    },
    {
        "id": 1759,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "21",
        "nombre": "TINGO"
    },
    {
        "id": 1760,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "TINGO DE PONASA"
    },
    {
        "id": 1761,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "02",
        "codigoDistrito": "04",
        "nombre": "TINGO DE SAPOSOA"
    },
    {
        "id": 1762,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "10",
        "codigoDistrito": "07",
        "nombre": "TINICACHI"
    },
    {
        "id": 1763,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "13",
        "nombre": "TINTAY"
    },
    {
        "id": 1764,
        "codigoPais": "PER",
        "codigoDepartamento": "08",
        "codigoProvincia": "05",
        "codigoDistrito": "25",
        "nombre": "TINTAY PUNCU"
    },
    {
        "id": 1765,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "TIPAN"
    },
    {
        "id": 1766,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "06",
        "codigoDistrito": "16",
        "nombre": "TOCMOCHE"
    },
    {
        "id": 1767,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "07",
        "codigoDistrito": "27",
        "nombre": "TOMAS"
    },
    {
        "id": 1768,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "TOMAY KICHWA"
    },
    {
        "id": 1769,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "10",
        "nombre": "TOMEPAMPA"
    },
    {
        "id": 1770,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "14",
        "nombre": "TORAYA"
    },
    {
        "id": 1771,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "05",
        "codigoDistrito": "15",
        "nombre": "TORIBIO CASANOVA"
    },
    {
        "id": 1772,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "08",
        "codigoDistrito": "11",
        "nombre": "TORO"
    },
    {
        "id": 1773,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "05",
        "codigoDistrito": "11",
        "nombre": "TOTORA"
    },
    {
        "id": 1774,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "02",
        "codigoDistrito": "08",
        "nombre": "TOTOS"
    },
    {
        "id": 1775,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "codigoDistrito": "04",
        "nombre": "TOURNAVISTA"
    },
    {
        "id": 1776,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "TRES DE DICIEMBRE"
    },
    {
        "id": 1777,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "09",
        "codigoDistrito": "09",
        "nombre": "TRES UNIDOS"
    },
    {
        "id": 1778,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "04",
        "codigoDistrito": "22",
        "nombre": "TRITA"
    },
    {
        "id": 1779,
        "codigoPais": "PER",
        "codigoDepartamento": "13",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "TUCUME"
    },
    {
        "id": 1780,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "13",
        "codigoDistrito": "04",
        "nombre": "TUMBADEN"
    },
    {
        "id": 1781,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "29",
        "nombre": "TUNAN MARCA"
    },
    {
        "id": 1782,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "03",
        "codigoDistrito": "12",
        "nombre": "TURPO"
    },
    {
        "id": 1783,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "UCHIZA"
    },
    {
        "id": 1784,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "02",
        "codigoDistrito": "06",
        "nombre": "UCHUMARCA"
    },
    {
        "id": 1785,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "21",
        "nombre": "UCHUMAYO"
    },
    {
        "id": 1786,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "08",
        "codigoDistrito": "15",
        "nombre": "UCO"
    },
    {
        "id": 1787,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "07",
        "codigoDistrito": "06",
        "nombre": "UMARI"
    },
    {
        "id": 1788,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "10",
        "codigoDistrito": "10",
        "nombre": "UNION AGUA BLANCA"
    },
    {
        "id": 1789,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "06",
        "codigoDistrito": "16",
        "nombre": "UPAHUACHO"
    },
    {
        "id": 1790,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "07",
        "codigoDistrito": "07",
        "nombre": "URANMARCA"
    },
    {
        "id": 1791,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "03",
        "codigoDistrito": "04",
        "nombre": "URARINAS"
    },
    {
        "id": 1792,
        "codigoPais": "PER",
        "codigoDepartamento": "12",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "USQUIL"
    },
    {
        "id": 1793,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "08",
        "nombre": "UTICYACU"
    },
    {
        "id": 1794,
        "codigoPais": "PER",
        "codigoDepartamento": "01",
        "codigoProvincia": "03",
        "codigoDistrito": "10",
        "nombre": "VALERA"
    },
    {
        "id": 1795,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "05",
        "codigoDistrito": "16",
        "nombre": "VEGUETA"
    },
    {
        "id": 1796,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "08",
        "codigoDistrito": "10",
        "nombre": "VEINTISIETE DE NOVIEMBRE"
    },
    {
        "id": 1797,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "07",
        "codigoDistrito": "08",
        "nombre": "VELILLE"
    },
    {
        "id": 1798,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "VICCO"
    },
    {
        "id": 1799,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "06",
        "codigoDistrito": "10",
        "nombre": "VILAVILA"
    },
    {
        "id": 1800,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "11",
        "nombre": "VILCABAMBA"
    },
    {
        "id": 1801,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "07",
        "codigoDistrito": "14",
        "nombre": "VILCANCHOS"
    },
    {
        "id": 1802,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "VILLA RICA"
    },
    {
        "id": 1803,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "01",
        "codigoDistrito": "13",
        "nombre": "VILQUE"
    },
    {
        "id": 1804,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "01",
        "codigoDistrito": "36",
        "nombre": "VIQUES"
    },
    {
        "id": 1805,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "06",
        "codigoDistrito": "12",
        "nombre": "VIRUNDO"
    },
    {
        "id": 1806,
        "codigoPais": "PER",
        "codigoDepartamento": "05",
        "codigoProvincia": "09",
        "codigoDistrito": "02",
        "nombre": "VISCHONGO"
    },
    {
        "id": 1807,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "03",
        "codigoDistrito": "05",
        "nombre": "VISTA ALEGRE"
    },
    {
        "id": 1808,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "08",
        "codigoDistrito": "03",
        "nombre": "VITOC"
    },
    {
        "id": 1809,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "22",
        "nombre": "VITOR"
    },
    {
        "id": 1810,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "01",
        "codigoDistrito": "08",
        "nombre": "WANCHAQ"
    },
    {
        "id": 1811,
        "codigoPais": "PER",
        "codigoDepartamento": "19",
        "codigoProvincia": "04",
        "codigoDistrito": "09",
        "nombre": "YAMANGO"
    },
    {
        "id": 1812,
        "codigoPais": "PER",
        "codigoDepartamento": "03",
        "codigoProvincia": "02",
        "codigoDistrito": "15",
        "nombre": "YANACA"
    },
    {
        "id": 1813,
        "codigoPais": "PER",
        "codigoDepartamento": "18",
        "codigoProvincia": "01",
        "codigoDistrito": "14",
        "nombre": "YANACANCHA"
    },
    {
        "id": 1814,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "08",
        "codigoDistrito": "10",
        "nombre": "YANAHUAYA"
    },
    {
        "id": 1815,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "05",
        "codigoDistrito": "01",
        "nombre": "YANAOCA"
    },
    {
        "id": 1816,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "04",
        "codigoDistrito": "08",
        "nombre": "YANATILE"
    },
    {
        "id": 1817,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "04",
        "codigoDistrito": "11",
        "nombre": "YAQUERANA"
    },
    {
        "id": 1818,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "04",
        "codigoDistrito": "13",
        "nombre": "YAUCA"
    },
    {
        "id": 1819,
        "codigoPais": "PER",
        "codigoDepartamento": "10",
        "codigoProvincia": "01",
        "codigoDistrito": "11",
        "nombre": "YAUCA DEL ROSARIO"
    },
    {
        "id": 1820,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "05",
        "codigoDistrito": "05",
        "nombre": "YAUTAN"
    },
    {
        "id": 1821,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "17",
        "codigoDistrito": "02",
        "nombre": "YAUYA"
    },
    {
        "id": 1822,
        "codigoPais": "PER",
        "codigoDepartamento": "11",
        "codigoProvincia": "03",
        "codigoDistrito": "34",
        "nombre": "YAUYOS"
    },
    {
        "id": 1823,
        "codigoPais": "PER",
        "codigoDepartamento": "06",
        "codigoProvincia": "09",
        "codigoDistrito": "09",
        "nombre": "YAUYUCAN"
    },
    {
        "id": 1824,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "05",
        "codigoDistrito": "03",
        "nombre": "YORONGOS"
    },
    {
        "id": 1825,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "02",
        "codigoDistrito": "02",
        "nombre": "YRAZOLA"
    },
    {
        "id": 1826,
        "codigoPais": "PER",
        "codigoDepartamento": "07",
        "codigoProvincia": "13",
        "codigoDistrito": "07",
        "nombre": "YUCAY"
    },
    {
        "id": 1827,
        "codigoPais": "PER",
        "codigoDepartamento": "02",
        "codigoProvincia": "06",
        "codigoDistrito": "07",
        "nombre": "YUPAN"
    },
    {
        "id": 1828,
        "codigoPais": "PER",
        "codigoDepartamento": "04",
        "codigoProvincia": "01",
        "codigoDistrito": "25",
        "nombre": "YURA"
    },
    {
        "id": 1829,
        "codigoPais": "PER",
        "codigoDepartamento": "15",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "YURIMAGUAS"
    },
    {
        "id": 1830,
        "codigoPais": "PER",
        "codigoDepartamento": "25",
        "codigoProvincia": "03",
        "codigoDistrito": "03",
        "nombre": "YURUA"
    },
    {
        "id": 1831,
        "codigoPais": "PER",
        "codigoDepartamento": "09",
        "codigoProvincia": "08",
        "codigoDistrito": "05",
        "nombre": "YUYAPICHIS"
    },
    {
        "id": 1832,
        "codigoPais": "PER",
        "codigoDepartamento": "21",
        "codigoProvincia": "03",
        "codigoDistrito": "14",
        "nombre": "ZAPATERO"
    },
    {
        "id": 1833,
        "codigoPais": "PER",
        "codigoDepartamento": "20",
        "codigoProvincia": "04",
        "codigoDistrito": "10",
        "nombre": "ZEPITA"
    },
    {
        "id": 1834,
        "codigoPais": "PER",
        "codigoDepartamento": "23",
        "codigoProvincia": "02",
        "codigoDistrito": "01",
        "nombre": "ZORRITOS"
    },
    {
        "id": 1835,
        "codigoPais": "PER",
        "codigoDepartamento": "14",
        "codigoProvincia": "04",
        "codigoDistrito": "15",
        "nombre": "ZUNIGA"
    }

];